import { DOCUMENT, CommonModule } from '@angular/common';
import { InjectionToken, ɵɵdefineInjectable, ɵɵinject, Injectable, Inject, Optional, SkipSelf, NgZone, EventEmitter, Component, Input, Output, ViewChild, Pipe, ChangeDetectionStrategy, forwardRef, HostBinding, Directive, HostListener, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormGroup, FormControl, Validators, NG_VALIDATORS, ReactiveFormsModule } from '@angular/forms';
import { LiveSafeMaterialModule } from '@livesafe/material';
import { Breakpoints, BreakpointObserver, LayoutModule } from '@angular/cdk/layout';
import { TimeagoModule } from 'ngx-timeago';
import { tap, catchError, shareReplay, map, switchMap, debounceTime, filter, distinctUntilChanged, take, takeUntil, finalize } from 'rxjs/operators';
import { Observable, of, Subject, throwError, empty, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/material/form-field';
import * as ɵngcc3 from '@livesafe/material';
import * as ɵngcc4 from '@angular/material/icon';
import * as ɵngcc5 from '@angular/material/input';
import * as ɵngcc6 from '@angular/material/autocomplete';
import * as ɵngcc7 from '@angular/material/core';
import * as ɵngcc8 from '@angular/material/button';
import * as ɵngcc9 from '@angular/common/http';
import * as ɵngcc10 from '@angular/forms';
import * as ɵngcc11 from '@angular/material/select';
import * as ɵngcc12 from '@angular/material/radio';
import * as ɵngcc13 from '@angular/material/dialog';
import * as ɵngcc14 from '@angular/cdk/layout';
import * as ɵngcc15 from 'ngx-timeago';
import * as ɵngcc16 from '@angular/platform-browser';
import * as ɵngcc17 from '@angular/material/tooltip';
import * as ɵngcc18 from '@angular/cdk/text-field';

const _c0 = ["mapPlaceholder"];
const _c1 = ["searchBar"];
function MapComponent_div_0_mat_icon_9_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 15);
    ɵngcc0.ɵɵlistener("click", function MapComponent_div_0_mat_icon_9_Template_mat_icon_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.clearSelectedLocation(); });
    ɵngcc0.ɵɵtext(1, "close");
    ɵngcc0.ɵɵelementEnd();
} }
function MapComponent_div_0_mat_option_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-option", 16);
    ɵngcc0.ɵɵelementStart(1, "div", 17);
    ɵngcc0.ɵɵelement(2, "mat-icon", 18);
    ɵngcc0.ɵɵelementStart(3, "div", 19);
    ɵngcc0.ɵɵelementStart(4, "div", 20);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 21);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const searchResult_r10 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", searchResult_r10);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(searchResult_r10.name);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(searchResult_r10.formatted_address);
} }
const _c2 = function (a0, a1) { return { "c-steelix": a0, "c-amaura": a1 }; };
function MapComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "mat-form-field", 7);
    ɵngcc0.ɵɵelementStart(3, "mat-label");
    ɵngcc0.ɵɵtext(4, "Address");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "mat-icon", 8);
    ɵngcc0.ɵɵtext(6, "search");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "input", 9, 10);
    ɵngcc0.ɵɵlistener("blur", function MapComponent_div_0_Template_input_blur_7_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.onSearchBarBlur(); })("input", function MapComponent_div_0_Template_input_input_7_listener() { ɵngcc0.ɵɵrestoreView(_r12); const _r4 = ɵngcc0.ɵɵreference(8); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.onSearchLocations(_r4.value); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, MapComponent_div_0_mat_icon_9_Template, 2, 0, "mat-icon", 11);
    ɵngcc0.ɵɵelementStart(10, "mat-autocomplete", 12, 13);
    ɵngcc0.ɵɵlistener("optionSelected", function MapComponent_div_0_Template_mat_autocomplete_optionSelected_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.onSelectLocation($event.option.value); });
    ɵngcc0.ɵɵtemplate(12, MapComponent_div_0_mat_option_12_Template, 8, 3, "mat-option", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r6 = ɵngcc0.ɵɵreference(11);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.searchBarPosition);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(6, _c2, !(ctx_r0.locationSearchResults == null ? null : ctx_r0.locationSearchResults.length), ctx_r0.locationSearchResults == null ? null : ctx_r0.locationSearchResults.length));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("matAutocomplete", _r6)("value", ctx_r0.value ? ctx_r0.value.address : "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.value && ctx_r0.value.coordinates);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.locationSearchResults);
} }
function MapComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵelementStart(1, "mat-form-field", 23);
    ɵngcc0.ɵɵelementStart(2, "mat-label");
    ɵngcc0.ɵɵtext(3, "Latitude");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "input", 24, 25);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "mat-form-field", 23);
    ɵngcc0.ɵɵelementStart(7, "mat-label");
    ɵngcc0.ɵɵtext(8, "Longitude");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(9, "input", 26, 27);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "button", 28);
    ɵngcc0.ɵɵlistener("click", function MapComponent_div_3_Template_button_click_11_listener() { ɵngcc0.ɵɵrestoreView(_r18); const _r15 = ɵngcc0.ɵɵreference(5); const _r16 = ɵngcc0.ɵɵreference(10); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.onCoordinatesRefresh(_r15.value, _r16.value); });
    ɵngcc0.ɵɵelementStart(12, "mat-icon");
    ɵngcc0.ɵɵtext(13, "autorenew");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("value", ctx_r2.value == null ? null : ctx_r2.value.coordinates.latitude);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("value", ctx_r2.value == null ? null : ctx_r2.value.coordinates.longitude);
} }
function MapComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 29);
    ɵngcc0.ɵɵlistener("click", function MapComponent_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.fullscreenClicked.emit(); });
    ɵngcc0.ɵɵelementStart(1, "mat-icon");
    ɵngcc0.ɵɵtext(2, "zoom_out_map");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function PhoneFieldComponent_mat_select_trigger_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-select-trigger");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("+", ctx_r0.value.dialingCode, "");
} }
function PhoneFieldComponent_mat_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-option", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const country_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", country_r2.countrycode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", country_r2.countryname + " +" + country_r2.phonecode, " ");
} }
function ColorPickerComponent_ng_container_1_mat_radio_button_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mat-radio-button", 3);
} if (rf & 2) {
    const i_r3 = ctx.$implicit;
    ɵngcc0.ɵɵclassMapInterpolate1("rainbow-background-", i_r3, "");
    ɵngcc0.ɵɵproperty("value", i_r3);
} }
function ColorPickerComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ColorPickerComponent_ng_container_1_mat_radio_button_1_Template, 1, 4, "mat-radio-button", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.colors);
} }
function ColorPickerComponent_ng_container_2_mat_radio_button_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mat-radio-button", 3);
} if (rf & 2) {
    const i_r5 = ctx.$implicit;
    ɵngcc0.ɵɵstyleProp("background-color", i_r5);
    ɵngcc0.ɵɵproperty("value", i_r5);
} }
function ColorPickerComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ColorPickerComponent_ng_container_2_mat_radio_button_1_Template, 1, 3, "mat-radio-button", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.colors);
} }
function AlertDialogComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.data == null ? null : ctx_r0.data.header);
} }
function AlertDialogComponent_button_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const btn_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("color", btn_r2.color || "primary")("mat-dialog-close", btn_r2.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", btn_r2.label, " ");
} }
const _c3 = function () { return { label: "Ok" }; };
const _c4 = function (a0) { return [a0]; };
const _c5 = ["topicInput"];
function ChatComponent_div_1_mat_form_field_5_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-form-field", 7);
    ɵngcc0.ɵɵelementStart(1, "input", 8, 9);
    ɵngcc0.ɵɵlistener("blur", function ChatComponent_div_1_mat_form_field_5_Template_input_blur_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.updateTopic($event); })("keydown.enter", function ChatComponent_div_1_mat_form_field_5_Template_input_keydown_enter_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.updateTopic($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("value", ctx_r2.topic);
} }
function ChatComponent_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.location);
} }
function ChatComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵprojection(2, 2);
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵlistener("click", function ChatComponent_div_1_Template_div_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.focusField(); });
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, ChatComponent_div_1_mat_form_field_5_Template, 3, 1, "mat-form-field", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵprojection(6, 3);
    ɵngcc0.ɵɵtemplate(7, ChatComponent_div_1_div_7_Template, 2, 1, "div", 6);
    ɵngcc0.ɵɵprojection(8, 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("header ", ctx_r0.edit ? "edit-mode" : "", "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassMapInterpolate1("mat-h3 topic ", ctx_r0.edit ? "edit-mode" : "", "");
    ɵngcc0.ɵɵproperty("title", !ctx_r0.admin ? "Click to Edit" : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.topic);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.edit);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.location);
} }
function ChatComponent_div_7_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 13);
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("date", ctx_r10.time);
} }
function ChatComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "div", 11);
    ɵngcc0.ɵɵelementStart(2, "span", 1);
    ɵngcc0.ɵɵtext(3, "submitter:\u00A0");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, ChatComponent_div_7_div_5_Template, 1, 1, "div", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r1.name && ctx_r1.name.trim() || "Anonymous", " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.time);
} }
const _c6 = [[["", "message", ""]], [["", "messageMedia", ""]], [["", "header", ""]], [["", "map", ""]], [["", "media", ""]]];
const _c7 = ["[message]", "[messageMedia]", "[header]", "[map]", "[media]"];
function MediaComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 4);
    ɵngcc0.ɵɵtext(1, "No Media");
    ɵngcc0.ɵɵelementEnd();
} }
function MediaComponent_livesafe_image_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "livesafe-image", 5);
    ɵngcc0.ɵɵlistener("click", function MediaComponent_livesafe_image_1_Template_livesafe_image_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const i_r5 = ctx.index; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onMediaClick(i_r5); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const entry_r4 = ctx.$implicit;
    const i_r5 = ctx.index;
    ɵngcc0.ɵɵproperty("type", entry_r4.type)("src", entry_r4.src);
    ɵngcc0.ɵɵattribute("aria-label", "view file " + i_r5 + " in media modal");
} }
function MediaComponent_livesafe_image_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "livesafe-image", 5);
    ɵngcc0.ɵɵlistener("click", function MediaComponent_livesafe_image_3_Template_livesafe_image_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onMediaClick(4); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("type", ctx_r2.media[4].type)("src", ctx_r2.media[4].src);
    ɵngcc0.ɵɵattribute("aria-label", "view file " + 4 + " in media modal");
} }
function MediaComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵlistener("click", function MediaComponent_span_4_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.onMediaClick(4); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("aria-label", "view more media items");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("+", ctx_r3.media.length - 4 > 99 ? 99 : ctx_r3.media.length - 4, "\n");
} }
function ImageComponent_ng_container_0_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon");
    ɵngcc0.ɵɵtext(1, "insert_photo");
    ɵngcc0.ɵɵelementEnd();
} }
function ImageComponent_ng_container_0_mat_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon");
    ɵngcc0.ɵɵtext(1, "videocam");
    ɵngcc0.ɵɵelementEnd();
} }
function ImageComponent_ng_container_0_mat_icon_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon");
    ɵngcc0.ɵɵtext(1, "keyboard_voice");
    ɵngcc0.ɵɵelementEnd();
} }
function ImageComponent_ng_container_0_mat_icon_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon");
    ɵngcc0.ɵɵtext(1, "description");
    ɵngcc0.ɵɵelementEnd();
} }
function ImageComponent_ng_container_0_mat_icon_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon");
    ɵngcc0.ɵɵtext(1, "block");
    ɵngcc0.ɵɵelementEnd();
} }
function ImageComponent_ng_container_0_mat_icon_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon");
    ɵngcc0.ɵɵtext(1, "priority_high");
    ɵngcc0.ɵɵelementEnd();
} }
function ImageComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵtemplate(2, ImageComponent_ng_container_0_mat_icon_2_Template, 2, 0, "mat-icon", 3);
    ɵngcc0.ɵɵtemplate(3, ImageComponent_ng_container_0_mat_icon_3_Template, 2, 0, "mat-icon", 3);
    ɵngcc0.ɵɵtemplate(4, ImageComponent_ng_container_0_mat_icon_4_Template, 2, 0, "mat-icon", 3);
    ɵngcc0.ɵɵtemplate(5, ImageComponent_ng_container_0_mat_icon_5_Template, 2, 0, "mat-icon", 3);
    ɵngcc0.ɵɵtemplate(6, ImageComponent_ng_container_0_mat_icon_6_Template, 2, 0, "mat-icon", 3);
    ɵngcc0.ɵɵtemplate(7, ImageComponent_ng_container_0_mat_icon_7_Template, 2, 0, "mat-icon", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngSwitch", ctx_r0.type);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r0.$media.CONTENT_TYPE.IMAGE);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r0.$media.CONTENT_TYPE.VIDEO);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r0.$media.CONTENT_TYPE.AUDIO);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r0.$media.CONTENT_TYPE.TEXT);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r0.$media.CONTENT_TYPE.UNKNOWN);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r0.$media.CONTENT_TYPE.ERROR);
} }
function ImageComponent_ng_container_2_img_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 6);
    ɵngcc0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("src", ɵngcc0.ɵɵpipeBind1(1, 1, ctx_r8.src$), ɵngcc0.ɵɵsanitizeUrl);
} }
function ImageComponent_ng_container_2_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 7);
    ɵngcc0.ɵɵtext(1, "videocam");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("matTooltip", ctx_r9.TOOLTIP_MESSAGE.VIDEO);
} }
function ImageComponent_ng_container_2_mat_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 7);
    ɵngcc0.ɵɵtext(1, "keyboard_voice");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("matTooltip", ctx_r10.TOOLTIP_MESSAGE.AUDIO);
} }
function ImageComponent_ng_container_2_mat_icon_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 7);
    ɵngcc0.ɵɵtext(1, "description");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("matTooltip", ctx_r11.TOOLTIP_MESSAGE.TEXT);
} }
function ImageComponent_ng_container_2_mat_icon_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 7);
    ɵngcc0.ɵɵtext(1, "block");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("matTooltip", ctx_r12.TOOLTIP_MESSAGE.UNKNOWN);
} }
function ImageComponent_ng_container_2_mat_icon_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 7);
    ɵngcc0.ɵɵtext(1, "priority_high");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("matTooltip", ctx_r13.TOOLTIP_MESSAGE.ERROR);
} }
function ImageComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 1);
    ɵngcc0.ɵɵtemplate(1, ImageComponent_ng_container_2_img_1_Template, 2, 3, "img", 4);
    ɵngcc0.ɵɵtemplate(2, ImageComponent_ng_container_2_mat_icon_2_Template, 2, 1, "mat-icon", 5);
    ɵngcc0.ɵɵtemplate(3, ImageComponent_ng_container_2_mat_icon_3_Template, 2, 1, "mat-icon", 5);
    ɵngcc0.ɵɵtemplate(4, ImageComponent_ng_container_2_mat_icon_4_Template, 2, 1, "mat-icon", 5);
    ɵngcc0.ɵɵtemplate(5, ImageComponent_ng_container_2_mat_icon_5_Template, 2, 1, "mat-icon", 5);
    ɵngcc0.ɵɵtemplate(6, ImageComponent_ng_container_2_mat_icon_6_Template, 2, 1, "mat-icon", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngSwitch", ctx_r1.type);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r1.$media.CONTENT_TYPE.IMAGE);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r1.$media.CONTENT_TYPE.VIDEO);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r1.$media.CONTENT_TYPE.AUDIO);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r1.$media.CONTENT_TYPE.TEXT);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r1.$media.CONTENT_TYPE.UNKNOWN);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r1.$media.CONTENT_TYPE.ERROR);
} }
const _c8 = ["*"];
const _c9 = [[["", "img", ""]], [["", "text", ""]]];
const _c10 = ["[img]", "[text]"];
class Location {
}
class Coordinates {
}

function geolocationFactory() {
    const geolocation = navigator.geolocation;
    return geolocation;
}
/**
 * Token that provides the device geolocation API.
 * Defaults to "navigator.geolocation"
 */
const GEOLOCATION_API = new InjectionToken('GEOLOCATION_API', {
    providedIn: 'root',
    factory: geolocationFactory
});
/**
 * Service that provides interface for interacting with device geolocation
 */
class GeolocationService {
    constructor(api) {
        this.api = api;
    }
    /**
     * Request permission and get the current position of the device
     */
    getCurrentPosition(options) {
        return new Observable(observer => {
            if (!this.api) {
                observer.complete();
            }
            else {
                this.api.getCurrentPosition(position => {
                    observer.next(position);
                    observer.complete();
                }, err => {
                    observer.error(err);
                }, options);
            }
        });
    }
    /**
     * Request permission and watch for changes to the current position.
     * Unsubscribe to to stop watching position
     */
    watchPosition(options) {
        return new Observable(observer => {
            if (!this.api) {
                observer.complete();
            }
            else {
                const watchId = this.api.watchPosition(position => {
                    observer.next(position);
                }, err => {
                    observer.error(err);
                }, options);
                return () => {
                    this.api.clearWatch(watchId);
                };
            }
        });
    }
}
GeolocationService.ɵfac = function GeolocationService_Factory(t) { return new (t || GeolocationService)(ɵngcc0.ɵɵinject(GEOLOCATION_API)); };
GeolocationService.ɵprov = ɵɵdefineInjectable({ factory: function GeolocationService_Factory() { return new GeolocationService(ɵɵinject(GEOLOCATION_API)); }, token: GeolocationService, providedIn: "root" });
GeolocationService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [GEOLOCATION_API,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GeolocationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [GEOLOCATION_API]
            }] }]; }, null); })();

const GMAPS_API_KEY = new InjectionToken('GMAPS_API_KEY');

/**
 * A cache that returns and observable and accepts a fallback function that returns an observable.
 *
 * internal cache is immutable
 *
 * @param cacheValues - determines if values will be cached or if just in flight requests. default true
 */
class Cache {
    constructor(cacheValues = true) {
        this.cacheValues = cacheValues;
        this.cache = new Map();
        this.inFlightRequests = new Map();
    }
    /**
     * Get and item from the cache. If no item is found call the fallback method to add to the cache
     */
    get(key, fallback) {
        if (this.has(key)) {
            return of(this.cache.get(key));
        }
        else if (this.inFlightRequests.has(key)) {
            return this.inFlightRequests.get(key).asObservable();
        }
        else {
            if (!fallback) {
                throw new Error('No cache found and no fallback provided');
            }
            this.inFlightRequests.set(key, new Subject());
            return fallback(key).pipe(tap(val => this.updateCacheAndInFlight(key, val)), catchError(error => {
                this.cancelInFlight(key);
                return throwError(error);
            }));
        }
    }
    /**
     * checks if a key exists in the map
     */
    has(key) {
        return this.cache.has(key);
    }
    /**
     * Set a property on the map
     */
    set(key, value) {
        this.cache.set(key, value);
        return this;
    }
    /**
     * Update the cache and notify any inflight observable
     */
    updateCacheAndInFlight(key, val) {
        const inFlight = this.inFlightRequests.get(key);
        if (this.cacheValues) {
            this.set(key, val);
        }
        if (inFlight) {
            inFlight.next(val);
            inFlight.complete();
        }
        this.inFlightRequests.delete(key);
    }
    /**
     * Cancel an inflight observable
     */
    cancelInFlight(key) {
        const inFlight = this.inFlightRequests.get(key);
        if (inFlight) {
            inFlight.complete();
            this.inFlightRequests.delete(key);
        }
    }
}

/**
 * Service for creating caches to be used in other services.
 */
class CacheService {
    /** creates an instance of Cache<K, V> */
    create(cacheValues = true) {
        return new Cache(cacheValues);
    }
}
CacheService.ɵfac = function CacheService_Factory(t) { return new (t || CacheService)(); };
CacheService.ɵprov = ɵɵdefineInjectable({ factory: function CacheService_Factory() { return new CacheService(); }, token: CacheService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CacheService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class ScriptService {
    constructor(cache, document, parent) {
        this.cache = cache;
        this.document = document;
        if (parent) {
            this.scripts = parent.scripts;
        }
        else {
            this.scripts = this.cache.create(true);
        }
    }
    /**
     * Async load a global script.
     * Script will only be loaded once no matter how many times this is called
     *
     * @param src - url to the script to be loaded;
     * @param checker - optional - if function returns true don't load
     */
    loadGlobalScript(src, checker) {
        let res;
        if (checker && checker()) {
            res = empty();
        }
        else {
            res = this.scripts.get(src, this.load.bind(this));
        }
        res.pipe(shareReplay()).subscribe();
        return res;
    }
    /**
     * create a new HTMLScriptElement and load the global script.
     *
     * @param src
     */
    load(src) {
        const doc = this.document;
        const script = doc.createElement('script');
        return new Observable(o => {
            script.src = src;
            script.onload = () => {
                o.next(true);
                o.complete();
                doc.body.removeChild(script);
            };
            script.onerror = err => o.error(err);
            doc.body.appendChild(script);
        });
    }
}
ScriptService.ɵfac = function ScriptService_Factory(t) { return new (t || ScriptService)(ɵngcc0.ɵɵinject(CacheService), ɵngcc0.ɵɵinject(DOCUMENT), ɵngcc0.ɵɵinject(ScriptService, 12)); };
ScriptService.ɵprov = ɵɵdefineInjectable({ factory: function ScriptService_Factory() { return new ScriptService(ɵɵinject(CacheService), ɵɵinject(DOCUMENT), ɵɵinject(ScriptService, 12)); }, token: ScriptService, providedIn: "root" });
ScriptService.ctorParameters = () => [
    { type: CacheService },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: ScriptService, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ScriptService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: CacheService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ScriptService, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, null); })();

class MapsApiLoader {
    constructor(script, apiKey) {
        this.script = script;
        this.apiKey = apiKey;
        this.scriptPath = `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=places&key=${this.apiKey}`;
    }
    load() {
        return this.script.loadGlobalScript(this.scriptPath).pipe(map(() => google.maps));
    }
}
MapsApiLoader.ɵfac = function MapsApiLoader_Factory(t) { return new (t || MapsApiLoader)(ɵngcc0.ɵɵinject(ScriptService), ɵngcc0.ɵɵinject(GMAPS_API_KEY)); };
MapsApiLoader.ɵprov = ɵɵdefineInjectable({ factory: function MapsApiLoader_Factory() { return new MapsApiLoader(ɵɵinject(ScriptService), ɵɵinject(GMAPS_API_KEY)); }, token: MapsApiLoader, providedIn: "root" });
MapsApiLoader.ctorParameters = () => [
    { type: ScriptService },
    { type: String, decorators: [{ type: Inject, args: [GMAPS_API_KEY,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MapsApiLoader, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ScriptService }, { type: String, decorators: [{
                type: Inject,
                args: [GMAPS_API_KEY]
            }] }]; }, null); })();
/**
 * Map Service that handles all map methods as observables.
 *
 * This allows us to lazy load in the google maps scripts only when they are needed but never repeat a request
 */
class MapService {
    constructor(api, zone, document) {
        this.api = api;
        this.zone = zone;
        this.document = document;
    }
    /**
     * Creates and instance of google.maps.Map
     */
    createMap(element, config) {
        return this.api.load().pipe(map(api => new api.Map(element, config)));
    }
    /**
     * Creates and instance of google.maps.Marker
     */
    createMarker(config, animation) {
        return this.api.load().pipe(map(api => {
            const marker = new api.Marker(config);
            if (animation) {
                marker.setAnimation(api.Animation[animation]);
            }
            return marker;
        }));
    }
    /**
     * Fetches ControlPosition enum
     */
    fetchControlPositions() {
        return this.api.load().pipe(map(api => {
            return api.ControlPosition;
        }));
    }
    /**
     * Creates and instance of google.maps.places.Autocomplete
     */
    createAutoComplete(element) {
        return this.api.load().pipe(map(api => new api.places.Autocomplete(element)));
    }
    createLatLngBounds() {
        return this.api.load().pipe(map(api => new api.LatLngBounds()));
    }
    /**
     * Search the google places api
     */
    findPlace(query) {
        return this.api.load().pipe(map(api => {
            const el = this.document.createElement('div');
            return new api.places.PlacesService(el);
        }), switchMap(service => {
            return new Observable(observer => {
                service.textSearch({ query }, res => this.zone.run(() => {
                    observer.next(res);
                    observer.complete();
                }));
            });
        }));
    }
    /**
     * Looks up location details based on a latLng
     */
    geocode(latLng) {
        return this.api.load().pipe(map(api => ({ api, geocoder: new api.Geocoder() })), switchMap(({ api, geocoder }) => {
            return new Observable(observer => {
                geocoder.geocode({ location: latLng }, (results, status) => {
                    this.zone.run(() => {
                        if (status === api.GeocoderStatus.OK) {
                            observer.next(results);
                            observer.complete();
                        }
                    });
                });
            });
        }));
    }
    /**
     * Add an event listener to a google maps object
     */
    addListener(instance, eventName) {
        return this.api.load().pipe(switchMap(api => new Observable(observer => {
            const handler = api.event.addListener(instance, eventName, event => {
                this.zone.run(() => {
                    observer.next(event);
                });
            });
            return () => {
                api.event.removeListener(handler);
            };
        })));
    }
}
MapService.ɵfac = function MapService_Factory(t) { return new (t || MapService)(ɵngcc0.ɵɵinject(MapsApiLoader), ɵngcc0.ɵɵinject(ɵngcc0.NgZone), ɵngcc0.ɵɵinject(DOCUMENT)); };
MapService.ɵprov = ɵɵdefineInjectable({ factory: function MapService_Factory() { return new MapService(ɵɵinject(MapsApiLoader), ɵɵinject(NgZone), ɵɵinject(DOCUMENT)); }, token: MapService, providedIn: "root" });
MapService.ctorParameters = () => [
    { type: MapsApiLoader },
    { type: NgZone },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MapService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: MapsApiLoader }, { type: ɵngcc0.NgZone }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();

const patch = (root, part) => Object.assign(root, part);

class MarkerOptions {
    constructor(seed = {}) {
        this.icon =
            'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjhweCIgaGVpZ2h0PSIzNHB4IiB2aWV3Qm94PSIwIDAgMjggMzQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzICg3MjUyMCkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+bWFwLWljb248L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz4KICAgICAgICA8bGluZWFyR3JhZGllbnQgeDE9IjE2LjA4OTk2NTQlIiB5MT0iMCUiIHgyPSI4My45MTAwMzQ2JSIgeTI9IjEwMCUiIGlkPSJsaW5lYXJHcmFkaWVudC0xIj4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iIzZERTFGNyIgb2Zmc2V0PSIwJSI+PC9zdG9wPgogICAgICAgICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjMzBCOURBIiBvZmZzZXQ9IjEwMCUiPjwvc3RvcD4KICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgPC9kZWZzPgogICAgPGcgaWQ9ImFjdGl2aXR5IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iYWN0aXZpdHktdGlwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtODE4LjAwMDAwMCwgLTI5NC4wMDAwMDApIiBmaWxsPSJ1cmwoI2xpbmVhckdyYWRpZW50LTEpIj4KICAgICAgICAgICAgPHBhdGggZD0iTTgzMiwzMjggQzgyMi42NjY2NjcsMzE5LjM4NjU4MyA4MTgsMzEyLjU3OTg4MyA4MTgsMzA3LjU3OTkwMSBDODE4LDMwMC4wNzk5MjkgODI0LjI2ODAxNCwyOTQgODMyLDI5NCBDODM5LjczMTk4NiwyOTQgODQ2LDMwMC4wNzk5MjkgODQ2LDMwNy41Nzk5MDEgQzg0NiwzMTIuNTc5ODgzIDg0MS4zMzMzMzMsMzE5LjM4NjU4MyA4MzIsMzI4IFogTTgzMiwzMTQuMDEyNDg2IEM4MzUuNjYyNTIsMzE0LjAxMjQ4NiA4MzguNjMxNTc5LDMxMS4xMzI1MiA4MzguNjMxNTc5LDMwNy41Nzk5MDEgQzgzOC42MzE1NzksMzA0LjAyNzI4MyA4MzUuNjYyNTIsMzAxLjE0NzMxNyA4MzIsMzAxLjE0NzMxNyBDODI4LjMzNzQ4LDMwMS4xNDczMTcgODI1LjM2ODQyMSwzMDQuMDI3MjgzIDgyNS4zNjg0MjEsMzA3LjU3OTkwMSBDODI1LjM2ODQyMSwzMTEuMTMyNTIgODI4LjMzNzQ4LDMxNC4wMTI0ODYgODMyLDMxNC4wMTI0ODYgWiIgaWQ9Im1hcC1pY29uIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=';
        patch(this, seed);
    }
}
const silverGoogleMapsStyle = [
    {
        elementType: 'geometry',
        stylers: [
            {
                color: '#f5f5f5'
            }
        ]
    },
    {
        elementType: 'labels.icon',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        elementType: 'labels.text.fill',
        stylers: [
            {
                color: '#616161'
            }
        ]
    },
    {
        elementType: 'labels.text.stroke',
        stylers: [
            {
                color: '#f5f5f5'
            }
        ]
    },
    {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [
            {
                color: '#bdbdbd'
            }
        ]
    },
    {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [
            {
                color: '#eeeeee'
            }
        ]
    },
    {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [
            {
                color: '#757575'
            }
        ]
    },
    {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [
            {
                color: '#e5e5e5'
            }
        ]
    },
    {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [
            {
                color: '#9e9e9e'
            }
        ]
    },
    {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [
            {
                color: '#ffffff'
            }
        ]
    },
    {
        featureType: 'road.arterial',
        elementType: 'labels.text.fill',
        stylers: [
            {
                color: '#757575'
            }
        ]
    },
    {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [
            {
                color: '#dadada'
            }
        ]
    },
    {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [
            {
                color: '#616161'
            }
        ]
    },
    {
        featureType: 'road.local',
        elementType: 'labels.text.fill',
        stylers: [
            {
                color: '#9e9e9e'
            }
        ]
    },
    {
        featureType: 'transit.line',
        elementType: 'geometry',
        stylers: [
            {
                color: '#e5e5e5'
            }
        ]
    },
    {
        featureType: 'transit.station',
        elementType: 'geometry',
        stylers: [
            {
                color: '#eeeeee'
            }
        ]
    },
    {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [
            {
                color: '#c9c9c9'
            }
        ]
    },
    {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [
            {
                color: '#9e9e9e'
            }
        ]
    }
];

class MapComponent {
    constructor(mapService, geolocationService) {
        this.mapService = mapService;
        this.geolocationService = geolocationService;
        this.mapConfig = {
            streetViewControl: false,
            fullscreenControl: false,
            mapTypeControl: false,
            zoom: 15,
            styles: silverGoogleMapsStyle
        };
        this.initialMarker = false;
        this.searchable = true;
        this.draggable = true;
        this.zoomControl = true;
        this.requestCurrentLocation = false;
        this.showCoordinates = false;
        this.searchBarPosition = 'center';
        this.showFullscreenBtn = false;
        this.locationSelected = new EventEmitter();
        this.fullscreenClicked = new EventEmitter();
        this.locationSearchResults = [];
        this.mapCenter = {
            latitude: 38.894,
            longitude: -77.0752
        };
        this.search$ = new Subject();
        this.onChange = (_) => { };
    }
    ngAfterViewInit() {
        this.searchSubscriber = this.search$
            .pipe(debounceTime(300), filter(query => !!query), distinctUntilChanged(), switchMap(query => this.mapService.findPlace(query)))
            .subscribe((results) => {
            this.locationSearchResults = results || [];
        });
        // Configure map with preset location, or a default location (Rosslyn, VA)
        const coordinates = this.value
            ? this.value.coordinates
            : this.mapCenter;
        const location = {
            lat: Number(coordinates.latitude),
            lng: Number(coordinates.longitude)
        };
        this.mapConfig = Object.assign(Object.assign({}, this.mapConfig), { draggable: this.draggable, zoomControl: this.zoomControl, center: location });
        this.mapService
            .createMap(this.mapPlaceholder.nativeElement, this.mapConfig)
            .pipe(take(1))
            .subscribe((mapRef) => {
            this.mapRef = mapRef;
            this.initialMarker
                ? this.setMapMarkerLocation(location)
                : this.mapRef.setCenter(location);
        });
        if (this.requestCurrentLocation) {
            this.geolocationService
                .getCurrentPosition()
                .pipe(switchMap((currentLocation) => this.mapService.geocode({
                lat: currentLocation.coords.latitude,
                lng: currentLocation.coords.longitude
            })), map((results) => results[0]))
                .subscribe((currentLocation) => this.initialMarker
                ? this.onSelectLocation(currentLocation)
                : this.mapRef.setCenter(currentLocation.geometry
                    ? {
                        lat: currentLocation.geometry.location.lat(),
                        lng: currentLocation.geometry.location.lng()
                    }
                    : location), () => console.warn('User has denied Geolocation'));
        }
    }
    ngOnDestroy() {
        if (this.searchSubscriber) {
            this.searchSubscriber.unsubscribe();
        }
    }
    writeValue(value) {
        this.value = value;
        if (!value || (value && !value.coordinates)) {
            this.clearMarker();
            this.selectedLocation = null;
        }
        else if (value.address &&
            !isNaN(value.coordinates.latitude) &&
            !isNaN(value.coordinates.longitude)) {
            const { latitude, longitude } = value.coordinates;
            this.onCoordinatesRefresh(latitude, longitude);
        }
    }
    ngOnChanges(changes) {
        if (changes.value &&
            !changes.value.firstChange &&
            changes.value.currentValue.toString() !== changes.value.previousValue.toString()) {
            this.writeValue(changes.value.currentValue);
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched() {
        // do nothing
    }
    createMapMarker() {
        this.mapService
            .createMarker(new MarkerOptions({ position: this.mapRef.getCenter() }), 'DROP')
            .pipe(take(1))
            .subscribe((marker) => {
            this.clearMarker();
            this.mapMarker = marker;
            this.mapMarker.setMap(this.mapRef);
            if (this.draggable) {
                // Make map marker draggable, and listen to drag event in order to update location info (address, coordinates, etc.)
                this.mapMarker.setDraggable(true);
                this.mapMarker.addListener('dragend', (_marker) => this.mapService
                    .geocode(this.mapMarker.getPosition())
                    .pipe(take(1))
                    .subscribe((result) => {
                    this.searchBar.nativeElement.value =
                        result[0].formatted_address || '';
                    this.onSelectLocation(result[0]);
                }));
            }
        });
    }
    onSearchLocations(query) {
        if (query) {
            this.search$.next(query);
        }
        else {
            this.locationSearchResults = [];
        }
    }
    onSelectLocation(place) {
        if (place.geometry) {
            const location = {
                address: place.formatted_address,
                coordinates: {
                    latitude: place.geometry.location.lat(),
                    longitude: place.geometry.location.lng()
                }
            };
            this.selectedLocation = location;
            this.setMapMarkerLocation({
                lat: Number(place.geometry.location.lat()),
                lng: Number(place.geometry.location.lng())
            });
            this.locationSelected.emit(location);
            this.value = location;
            this.onChange(location);
        }
        this.locationSearchResults = [];
    }
    onCoordinatesRefresh(latitude, longitude) {
        this.mapService
            .geocode({
            lat: Number(latitude),
            lng: Number(longitude)
        })
            .pipe(take(1))
            .subscribe((result) => {
            this.onSelectLocation(result[0]);
        });
    }
    onSearchBarBlur() {
        if (this.selectedLocation && this.value) {
            this.searchBar.nativeElement.value = this.value.address;
        }
    }
    setMapMarkerLocation(location) {
        if (this.mapRef) {
            this.mapRef.setCenter(location);
            this.createMapMarker();
        }
    }
    clearMarker() {
        if (this.mapMarker) {
            // Remove map marker if it already exists
            this.mapMarker.setMap(null);
        }
    }
    clearSelectedLocation() {
        this.clearMarker();
        this.selectedLocation = null;
        this.value = null;
        this.onChange(null);
    }
}
MapComponent.ɵfac = function MapComponent_Factory(t) { return new (t || MapComponent)(ɵngcc0.ɵɵdirectiveInject(MapService), ɵngcc0.ɵɵdirectiveInject(GeolocationService)); };
MapComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MapComponent, selectors: [["livesafe-map"]], viewQuery: function MapComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
        ɵngcc0.ɵɵviewQuery(_c1, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.mapPlaceholder = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.searchBar = _t.first);
    } }, inputs: { mapConfig: "mapConfig", initialMarker: "initialMarker", searchable: "searchable", draggable: "draggable", zoomControl: "zoomControl", requestCurrentLocation: "requestCurrentLocation", showCoordinates: "showCoordinates", searchBarPosition: "searchBarPosition", showFullscreenBtn: "showFullscreenBtn", value: "value" }, outputs: { locationSelected: "locationSelected", fullscreenClicked: "fullscreenClicked" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NG_VALUE_ACCESSOR, useExisting: MapComponent, multi: true }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 5, vars: 3, consts: [["class", "address-search-container", 3, "ngClass", 4, "ngIf"], ["tabindex", "-1", 1, "map-container", "f-1"], ["mapPlaceholder", ""], ["class", "coordinates-container", 4, "ngIf"], ["mat-icon-button", "", "class", "fullscreen-button", 3, "click", 4, "ngIf"], [1, "address-search-container", 3, "ngClass"], [1, "p-r"], ["livesafeMat", "", "appearance", "outline", "stroke", "white", 1, "d-b"], ["matPrefix", "", "livesafeMat", "", 3, "ngClass"], ["matInput", "", "placeholder", "Enter Address", 3, "matAutocomplete", "value", "blur", "input"], ["searchBar", ""], ["matSuffix", "", "fontSet", "material-icons-round", "class", "close", 3, "click", 4, "ngIf"], [3, "optionSelected"], ["autoComplete", "matAutocomplete"], [3, "value", 4, "ngFor", "ngForOf"], ["matSuffix", "", "fontSet", "material-icons-round", 1, "close", 3, "click"], [3, "value"], [1, "d-f"], ["livesafeMat", "", "fontSet", "livesafe-icons", "fontIcon", "i-map-pin", "size", "small", 1, "c-graveler"], [1, "search-result-container"], [1, "search-result-label"], [1, "search-result-address"], [1, "coordinates-container"], ["appearance", "outline"], ["matInput", "", "type", "number", "step", "any", "placeholder", "Latitude", 3, "value"], ["latitude", ""], ["matInput", "", "type", "number", "step", "any", "placeholder", "Longitude", 3, "value"], ["longitude", ""], ["mat-mini-fab", "", "livesafeMat", "", "aria-label", "refresh map", 3, "click"], ["mat-icon-button", "", 1, "fullscreen-button", 3, "click"]], template: function MapComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, MapComponent_div_0_Template, 13, 9, "div", 0);
        ɵngcc0.ɵɵelement(1, "div", 1, 2);
        ɵngcc0.ɵɵtemplate(3, MapComponent_div_3_Template, 14, 2, "div", 3);
        ɵngcc0.ɵɵtemplate(4, MapComponent_button_4_Template, 3, 0, "button", 4);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.searchable);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.searchable && ctx.showCoordinates);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showFullscreenBtn);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass, ɵngcc2.MatFormField, ɵngcc3.LiveSafeMatDirective, ɵngcc2.MatLabel, ɵngcc4.MatIcon, ɵngcc2.MatPrefix, ɵngcc5.MatInput, ɵngcc6.MatAutocompleteTrigger, ɵngcc6.MatAutocomplete, ɵngcc1.NgForOf, ɵngcc2.MatSuffix, ɵngcc7.MatOption, ɵngcc8.MatButton], styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;height:100%;position:relative;width:100%}.close[_ngcontent-%COMP%]{cursor:pointer}.address-search-container[_ngcontent-%COMP%]{border:none;box-shadow:-10px 10px 20px 0 rgba(30,30,30,.05);left:0;margin:0 auto;max-width:535px;position:absolute;right:0;width:100%;z-index:500}.address-search-container.left[_ngcontent-%COMP%]{margin:31px auto 0 28px}.address-search-container.center[_ngcontent-%COMP%]{margin:31px auto 0}.address-search-container.right[_ngcontent-%COMP%]{float:right;margin:31px 28px 0 auto}.address-search-container[_ngcontent-%COMP%]     .mat-form-field-wrapper{margin:0;padding-bottom:0}.address-search-container[_ngcontent-%COMP%]     .mat-form-field-outline{border-radius:5px 5px 0 0}  .search-result-container{max-width:410px}  .search-result-label{font-weight:700;line-height:22px;overflow:hidden;text-overflow:ellipsis}  .search-result-address{font-size:14px;font-weight:300;line-height:19px;overflow:hidden;text-overflow:ellipsis}.coordinates-container[_ngcontent-%COMP%]{margin-top:17px}.coordinates-container[_ngcontent-%COMP%]   mat-form-field[_ngcontent-%COMP%]{margin-right:36px;width:170px}.fullscreen-button[_ngcontent-%COMP%]{background-color:#fff;border-radius:0;height:26px;left:8px;line-height:1;position:absolute;top:8px;width:26px;z-index:1}"] });
MapComponent.ctorParameters = () => [
    { type: MapService },
    { type: GeolocationService }
];
MapComponent.propDecorators = {
    value: [{ type: Input }],
    mapConfig: [{ type: Input }],
    initialMarker: [{ type: Input }],
    searchable: [{ type: Input }],
    draggable: [{ type: Input }],
    zoomControl: [{ type: Input }],
    requestCurrentLocation: [{ type: Input }],
    showCoordinates: [{ type: Input }],
    searchBarPosition: [{ type: Input }],
    showFullscreenBtn: [{ type: Input }],
    locationSelected: [{ type: Output }],
    fullscreenClicked: [{ type: Output }],
    mapPlaceholder: [{ type: ViewChild, args: ['mapPlaceholder',] }],
    searchBar: [{ type: ViewChild, args: ['searchBar',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MapComponent, [{
        type: Component,
        args: [{
                selector: 'livesafe-map',
                template: "<div *ngIf=\"searchable\" class=\"address-search-container\" [ngClass]=\"searchBarPosition\">\n  <div class=\"p-r\">\n    <mat-form-field livesafeMat class=\"d-b\" appearance=\"outline\" stroke=\"white\">\n      <mat-label>Address</mat-label>\n      <mat-icon [ngClass]=\"{ 'c-steelix': !locationSearchResults?.length, 'c-amaura': locationSearchResults?.length }\"\n        matPrefix livesafeMat>search</mat-icon>\n      <input matInput placeholder=\"Enter Address\" (blur)=\"onSearchBarBlur()\"\n        (input)=\"onSearchLocations(searchBar.value)\" #searchBar [matAutocomplete]=\"autoComplete\"\n        [value]=\"value ? value.address : ''\" />\n      <mat-icon *ngIf=\"value && value.coordinates\" (click)=\"clearSelectedLocation()\" matSuffix\n        fontSet=\"material-icons-round\" class=\"close\">close</mat-icon>\n      <mat-autocomplete #autoComplete=\"matAutocomplete\" (optionSelected)=\"onSelectLocation($event.option.value)\">\n        <mat-option *ngFor=\"let searchResult of locationSearchResults\" [value]=\"searchResult\">\n          <div class=\"d-f\">\n            <mat-icon livesafeMat fontSet=\"livesafe-icons\" fontIcon=\"i-map-pin\" size=\"small\" class=\"c-graveler\">\n            </mat-icon>\n            <div class=\"search-result-container\">\n              <div class=\"search-result-label\">{{ searchResult.name }}</div>\n              <div class=\"search-result-address\">{{ searchResult.formatted_address }}</div>\n            </div>\n          </div>\n        </mat-option>\n      </mat-autocomplete>\n    </mat-form-field>\n  </div>\n</div>\n\n<div class=\"map-container f-1\" #mapPlaceholder tabindex=\"-1\"></div>\n\n<div *ngIf=\"searchable && showCoordinates\" class=\"coordinates-container\">\n  <mat-form-field appearance=\"outline\">\n    <mat-label>Latitude</mat-label>\n    <input matInput type=\"number\" step=\"any\" placeholder=\"Latitude\" [value]=\"value?.coordinates.latitude\" #latitude />\n  </mat-form-field>\n  <mat-form-field appearance=\"outline\">\n    <mat-label>Longitude</mat-label>\n    <input matInput type=\"number\" step=\"any\" placeholder=\"Longitude\" [value]=\"value?.coordinates.longitude\" #longitude />\n  </mat-form-field>\n  <button mat-mini-fab livesafeMat (click)=\"onCoordinatesRefresh(latitude.value, longitude.value)\"\n    aria-label=\"refresh map\">\n    <mat-icon>autorenew</mat-icon>\n  </button>\n</div>\n\n<button *ngIf=\"showFullscreenBtn\" mat-icon-button class=\"fullscreen-button\" (click)=\"fullscreenClicked.emit()\">\n  <mat-icon>zoom_out_map</mat-icon>\n</button>\n",
                providers: [
                    { provide: NG_VALUE_ACCESSOR, useExisting: MapComponent, multi: true }
                ],
                styles: [":host{display:flex;flex-direction:column;height:100%;position:relative;width:100%}.close{cursor:pointer}.address-search-container{border:none;box-shadow:-10px 10px 20px 0 rgba(30,30,30,.05);left:0;margin:0 auto;max-width:535px;position:absolute;right:0;width:100%;z-index:500}.address-search-container.left{margin:31px auto 0 28px}.address-search-container.center{margin:31px auto 0}.address-search-container.right{float:right;margin:31px 28px 0 auto}.address-search-container ::ng-deep .mat-form-field-wrapper{margin:0;padding-bottom:0}.address-search-container ::ng-deep .mat-form-field-outline{border-radius:5px 5px 0 0}::ng-deep .search-result-container{max-width:410px}::ng-deep .search-result-label{font-weight:700;line-height:22px;overflow:hidden;text-overflow:ellipsis}::ng-deep .search-result-address{font-size:14px;font-weight:300;line-height:19px;overflow:hidden;text-overflow:ellipsis}.coordinates-container{margin-top:17px}.coordinates-container mat-form-field{margin-right:36px;width:170px}.fullscreen-button{background-color:#fff;border-radius:0;height:26px;left:8px;line-height:1;position:absolute;top:8px;width:26px;z-index:1}"]
            }]
    }], function () { return [{ type: MapService }, { type: GeolocationService }]; }, { mapConfig: [{
            type: Input
        }], initialMarker: [{
            type: Input
        }], searchable: [{
            type: Input
        }], draggable: [{
            type: Input
        }], zoomControl: [{
            type: Input
        }], requestCurrentLocation: [{
            type: Input
        }], showCoordinates: [{
            type: Input
        }], searchBarPosition: [{
            type: Input
        }], showFullscreenBtn: [{
            type: Input
        }], locationSelected: [{
            type: Output
        }], fullscreenClicked: [{
            type: Output
        }], value: [{
            type: Input
        }], mapPlaceholder: [{
            type: ViewChild,
            args: ['mapPlaceholder']
        }], searchBar: [{
            type: ViewChild,
            args: ['searchBar']
        }] }); })();

const LIVESAFE_COMMON_OPTIONS = new InjectionToken('ModuleOptions');

class UnescapePipe {
    transform(value = '') {
        return value.replace(/&[#A-Za-z0-9]+;/g, match => UnescapePipe.HTML_ENTITIES.get(match.slice(1, -1)) || match);
    }
}
UnescapePipe.ɵfac = function UnescapePipe_Factory(t) { return new (t || UnescapePipe)(); };
UnescapePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "unescape", type: UnescapePipe, pure: true });
UnescapePipe.HTML_ENTITIES = new Map([
    ['nbsp', ' '],
    ['lt', '<'],
    ['gt', '>'],
    ['quot', '"'],
    ['amp', '&'],
    // tslint:disable-next-line: quotemark
    ['apos', "'"]
]);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UnescapePipe, [{
        type: Pipe,
        args: [{
                name: 'unescape'
            }]
    }], null, null); })();

const DefaultCountryList = [
    {
        countryname: 'Vanuatu',
        phonecode: '678',
        countrycode: 'VU',
        emergencynumber: '112'
    },
    {
        countryname: 'Vietnam',
        phonecode: '84',
        countrycode: 'VN',
        emergencynumber: '113'
    },
    {
        countryname: 'Ecuador',
        phonecode: '593',
        countrycode: 'EC',
        emergencynumber: '101'
    },
    {
        countryname: 'U.S. Virgin Islands',
        phonecode: '1',
        countrycode: 'VI',
        emergencynumber: '911'
    },
    {
        countryname: 'Algeria',
        phonecode: '213',
        countrycode: 'DZ',
        emergencynumber: '17'
    },
    {
        countryname: 'British Virgin Islands',
        phonecode: '1',
        countrycode: 'VG',
        emergencynumber: '999'
    },
    {
        countryname: 'Venezuela',
        phonecode: '58',
        countrycode: 'VE',
        emergencynumber: '171'
    },
    {
        countryname: 'Dominica',
        phonecode: '1',
        countrycode: 'DM',
        emergencynumber: '999'
    },
    {
        countryname: 'Saint Vincent and the Grenadines',
        phonecode: '1',
        countrycode: 'VC',
        emergencynumber: '911'
    },
    {
        countryname: 'Dominican Republic',
        phonecode: '1',
        countrycode: 'DO',
        emergencynumber: '911'
    },
    {
        countryname: 'Vatican',
        phonecode: '379',
        countrycode: 'VA',
        emergencynumber: '112'
    },
    {
        countryname: 'Germany',
        phonecode: '49',
        countrycode: 'DE',
        emergencynumber: '110'
    },
    {
        countryname: 'Uzbekistan',
        phonecode: '998',
        countrycode: 'UZ',
        emergencynumber: '102'
    },
    {
        countryname: 'Uruguay',
        phonecode: '598',
        countrycode: 'UY',
        emergencynumber: '911'
    },
    {
        countryname: 'Denmark',
        phonecode: '45',
        countrycode: 'DK',
        emergencynumber: '112'
    },
    {
        countryname: 'Djibouti',
        phonecode: '253',
        countrycode: 'DJ',
        emergencynumber: '17'
    },
    {
        countryname: 'United States',
        phonecode: '1',
        countrycode: 'US',
        emergencynumber: '911'
    },
    {
        countryname: 'United States Minor Outlying Islands',
        phonecode: '1',
        countrycode: 'UM',
        emergencynumber: '911'
    },
    {
        countryname: 'Uganda',
        phonecode: '256',
        countrycode: 'UG',
        emergencynumber: '999'
    },
    {
        countryname: 'Ukraine',
        phonecode: '380',
        countrycode: 'UA',
        emergencynumber: '112'
    },
    {
        countryname: 'Ethiopia',
        phonecode: '251',
        countrycode: 'ET',
        emergencynumber: '991'
    },
    {
        countryname: 'Spain',
        phonecode: '34',
        countrycode: 'ES',
        emergencynumber: '112'
    },
    {
        countryname: 'Eritrea',
        phonecode: '291',
        countrycode: 'ER'
    },
    {
        countryname: 'Western Sahara',
        phonecode: '212',
        countrycode: 'EH',
        emergencynumber: '150'
    },
    {
        countryname: 'Egypt',
        phonecode: '20',
        countrycode: 'EG',
        emergencynumber: '122'
    },
    {
        countryname: 'Estonia',
        phonecode: '372',
        countrycode: 'EE',
        emergencynumber: '112'
    },
    {
        countryname: 'Tanzania',
        phonecode: '255',
        countrycode: 'TZ',
        emergencynumber: '112'
    },
    {
        countryname: 'Trinidad and Tobago',
        phonecode: '1',
        countrycode: 'TT',
        emergencynumber: '999'
    },
    {
        countryname: 'Taiwan',
        phonecode: '886',
        countrycode: 'TW',
        emergencynumber: '110'
    },
    {
        countryname: 'Tuvalu',
        phonecode: '688',
        countrycode: 'TV',
        emergencynumber: '911'
    },
    {
        countryname: 'Grenada',
        phonecode: '1',
        countrycode: 'GD',
        emergencynumber: '911'
    },
    {
        countryname: 'Georgia',
        phonecode: '995',
        countrycode: 'GE',
        emergencynumber: '112'
    },
    {
        countryname: 'French Guiana',
        phonecode: '594',
        countrycode: 'GF',
        emergencynumber: '112'
    },
    {
        countryname: 'Gabon',
        phonecode: '241',
        countrycode: 'GA',
        emergencynumber: '1730'
    },
    {
        countryname: 'United Kingdom',
        phonecode: '44',
        countrycode: 'GB',
        emergencynumber: '999'
    },
    {
        countryname: 'France',
        phonecode: '33',
        countrycode: 'FR',
        emergencynumber: '112'
    },
    {
        countryname: 'Faroe Islands',
        phonecode: '298',
        countrycode: 'FO',
        emergencynumber: '112'
    },
    {
        countryname: 'Falkland Islands',
        phonecode: '500',
        countrycode: 'FK',
        emergencynumber: '999'
    },
    {
        countryname: 'Fiji',
        phonecode: '679',
        countrycode: 'FJ',
        emergencynumber: '911'
    },
    {
        countryname: 'Micronesia',
        phonecode: '691',
        countrycode: 'FM',
        emergencynumber: '911'
    },
    {
        countryname: 'Finland',
        phonecode: '358',
        countrycode: 'FI',
        emergencynumber: '112'
    },
    {
        countryname: 'Samoa',
        phonecode: '685',
        countrycode: 'WS',
        emergencynumber: '995'
    },
    {
        countryname: 'Guyana',
        phonecode: '592',
        countrycode: 'GY',
        emergencynumber: '911'
    },
    {
        countryname: 'Guinea Bissau',
        phonecode: '245',
        countrycode: 'GW'
    },
    {
        countryname: 'Guam',
        phonecode: '1',
        countrycode: 'GU',
        emergencynumber: '911'
    },
    {
        countryname: 'Guatemala',
        phonecode: '502',
        countrycode: 'GT',
        emergencynumber: '110'
    },
    {
        countryname: 'Greece',
        phonecode: '30',
        countrycode: 'GR',
        emergencynumber: '112'
    },
    {
        countryname: 'Equatorial Guinea',
        phonecode: '240',
        countrycode: 'GQ'
    },
    {
        countryname: 'Wallis and Futuna',
        phonecode: '681',
        countrycode: 'WF'
    },
    {
        countryname: 'Guadeloupe',
        phonecode: '590',
        countrycode: 'GP',
        emergencynumber: '112'
    },
    {
        countryname: 'Guinea',
        phonecode: '224',
        countrycode: 'GN',
        emergencynumber: '122'
    },
    {
        countryname: 'Gambia',
        phonecode: '220',
        countrycode: 'GM',
        emergencynumber: '117'
    },
    {
        countryname: 'Greenland',
        phonecode: '299',
        countrycode: 'GL',
        emergencynumber: '112'
    },
    {
        countryname: 'Gibraltar',
        phonecode: '350',
        countrycode: 'GI',
        emergencynumber: '112'
    },
    {
        countryname: 'Ghana',
        phonecode: '233',
        countrycode: 'GH',
        emergencynumber: '191'
    },
    {
        countryname: 'Guernsey',
        phonecode: '44',
        countrycode: 'GG',
        emergencynumber: '999'
    },
    {
        countryname: 'Reunion',
        phonecode: '262',
        countrycode: 'RE',
        emergencynumber: '17'
    },
    {
        countryname: 'Romania',
        phonecode: '40',
        countrycode: 'RO',
        emergencynumber: '112'
    },
    {
        countryname: 'Austria',
        phonecode: '43',
        countrycode: 'AT',
        emergencynumber: '112'
    },
    {
        countryname: 'American Samoa',
        phonecode: '1',
        countrycode: 'AS',
        emergencynumber: '911'
    },
    {
        countryname: 'Argentina',
        phonecode: '54',
        countrycode: 'AR',
        emergencynumber: '911'
    },
    {
        countryname: 'Aland Islands',
        phonecode: '358',
        countrycode: 'AX',
        emergencynumber: '112'
    },
    {
        countryname: 'Qatar',
        phonecode: '974',
        countrycode: 'QA',
        emergencynumber: '999'
    },
    {
        countryname: 'Aruba',
        phonecode: '297',
        countrycode: 'AW',
        emergencynumber: '911'
    },
    {
        countryname: 'Australia',
        phonecode: '61',
        countrycode: 'AU',
        emergencynumber: '000'
    },
    {
        countryname: 'Azerbaijan',
        phonecode: '994',
        countrycode: 'AZ',
        emergencynumber: '102'
    },
    {
        countryname: 'Bosnia and Herzegovina',
        phonecode: '387',
        countrycode: 'BA',
        emergencynumber: '122'
    },
    {
        countryname: 'Portugal',
        phonecode: '351',
        countrycode: 'PT',
        emergencynumber: '112'
    },
    {
        countryname: 'Andorra',
        phonecode: '376',
        countrycode: 'AD',
        emergencynumber: '112'
    },
    {
        countryname: 'Palau',
        phonecode: '680',
        countrycode: 'PW',
        emergencynumber: '911'
    },
    {
        countryname: 'Antigua and Barbuda',
        phonecode: '1',
        countrycode: 'AG',
        emergencynumber: '911'
    },
    {
        countryname: 'United Arab Emirates',
        phonecode: '971',
        countrycode: 'AE',
        emergencynumber: '999'
    },
    {
        countryname: 'Puerto Rico',
        phonecode: '1',
        countrycode: 'PR',
        emergencynumber: '911'
    },
    {
        countryname: 'Afghanistan',
        phonecode: '93',
        countrycode: 'AF',
        emergencynumber: '119'
    },
    {
        countryname: 'Palestinian Territory',
        phonecode: '970',
        countrycode: 'PS'
    },
    {
        countryname: 'Albania',
        phonecode: '355',
        countrycode: 'AL',
        emergencynumber: '129'
    },
    {
        countryname: 'Anguilla',
        phonecode: '1',
        countrycode: 'AI',
        emergencynumber: '911'
    },
    {
        countryname: 'Angola',
        phonecode: '244',
        countrycode: 'AO',
        emergencynumber: '113'
    },
    {
        countryname: 'Paraguay',
        phonecode: '595',
        countrycode: 'PY',
        emergencynumber: '911'
    },
    {
        countryname: 'Armenia',
        phonecode: '374',
        countrycode: 'AM',
        emergencynumber: '102'
    },
    {
        countryname: 'Togo',
        phonecode: '228',
        countrycode: 'TG',
        emergencynumber: '117'
    },
    {
        countryname: 'Botswana',
        phonecode: '267',
        countrycode: 'BW',
        emergencynumber: '999'
    },
    {
        countryname: 'Belarus',
        phonecode: '375',
        countrycode: 'BY',
        emergencynumber: '102'
    },
    {
        countryname: 'Chad',
        phonecode: '235',
        countrycode: 'TD',
        emergencynumber: '17'
    },
    {
        countryname: 'Bahamas',
        phonecode: '1',
        countrycode: 'BS',
        emergencynumber: '911'
    },
    {
        countryname: 'Tokelau',
        phonecode: '690',
        countrycode: 'TK'
    },
    {
        countryname: 'Brazil',
        phonecode: '55',
        countrycode: 'BR',
        emergencynumber: '190'
    },
    {
        countryname: 'Tajikistan',
        phonecode: '992',
        countrycode: 'TJ',
        emergencynumber: '112'
    },
    {
        countryname: 'Thailand',
        phonecode: '66',
        countrycode: 'TH',
        emergencynumber: '191'
    },
    {
        countryname: 'Bhutan',
        phonecode: '975',
        countrycode: 'BT',
        emergencynumber: '113'
    },
    {
        countryname: 'Tonga',
        phonecode: '676',
        countrycode: 'TO',
        emergencynumber: '911'
    },
    {
        countryname: 'Tunisia',
        phonecode: '216',
        countrycode: 'TN',
        emergencynumber: '197'
    },
    {
        countryname: 'Turkmenistan',
        phonecode: '993',
        countrycode: 'TM'
    },
    {
        countryname: 'East Timor',
        phonecode: '670',
        countrycode: 'TL',
        emergencynumber: '112'
    },
    {
        countryname: 'Canada',
        phonecode: '1',
        countrycode: 'CA',
        emergencynumber: '911'
    },
    {
        countryname: 'Turkey',
        phonecode: '90',
        countrycode: 'TR',
        emergencynumber: '155'
    },
    {
        countryname: 'Belize',
        phonecode: '501',
        countrycode: 'BZ',
        emergencynumber: '911'
    },
    {
        countryname: 'Burkina Faso',
        phonecode: '226',
        countrycode: 'BF',
        emergencynumber: '17'
    },
    {
        countryname: 'El Salvador',
        phonecode: '503',
        countrycode: 'SV',
        emergencynumber: '911'
    },
    {
        countryname: 'Bulgaria',
        phonecode: '359',
        countrycode: 'BG',
        emergencynumber: '112'
    },
    {
        countryname: 'Bahrain',
        phonecode: '973',
        countrycode: 'BH',
        emergencynumber: '999'
    },
    {
        countryname: 'South Sudan',
        phonecode: '211',
        countrycode: 'SS'
    },
    {
        countryname: 'Burundi',
        phonecode: '257',
        countrycode: 'BI',
        emergencynumber: '117'
    },
    {
        countryname: 'Sao Tome and Principe',
        phonecode: '239',
        countrycode: 'ST'
    },
    {
        countryname: 'Barbados',
        phonecode: '1',
        countrycode: 'BB',
        emergencynumber: '211'
    },
    {
        countryname: 'Syria',
        phonecode: '963',
        countrycode: 'SY',
        emergencynumber: '112'
    },
    {
        countryname: 'Swaziland',
        phonecode: '268',
        countrycode: 'SZ'
    },
    {
        countryname: 'Bangladesh',
        phonecode: '880',
        countrycode: 'BD',
        emergencynumber: '999'
    },
    {
        countryname: 'Belgium',
        phonecode: '32',
        countrycode: 'BE',
        emergencynumber: '112'
    },
    {
        countryname: 'Sint Maarten',
        phonecode: '599',
        countrycode: 'SX'
    },
    {
        countryname: 'Brunei',
        phonecode: '673',
        countrycode: 'BN',
        emergencynumber: '993'
    },
    {
        countryname: 'Bolivia',
        phonecode: '591',
        countrycode: 'BO',
        emergencynumber: '110'
    },
    {
        countryname: 'Bonaire, Saint Eustatius and Saba ',
        phonecode: '599',
        countrycode: 'BQ'
    },
    {
        countryname: 'Benin',
        phonecode: '229',
        countrycode: 'BJ'
    },
    {
        countryname: 'Turks and Caicos Islands',
        phonecode: '1',
        countrycode: 'TC',
        emergencynumber: '911'
    },
    {
        countryname: 'Saint Barthelemy',
        phonecode: '590',
        countrycode: 'BL'
    },
    {
        countryname: 'Bermuda',
        phonecode: '1',
        countrycode: 'BM',
        emergencynumber: '911'
    },
    {
        countryname: 'Czech Republic',
        phonecode: '420',
        countrycode: 'CZ',
        emergencynumber: '112'
    },
    {
        countryname: 'Sudan',
        phonecode: '249',
        countrycode: 'SD',
        emergencynumber: '999'
    },
    {
        countryname: 'Cyprus',
        phonecode: '357',
        countrycode: 'CY',
        emergencynumber: '112'
    },
    {
        countryname: 'Seychelles',
        phonecode: '248',
        countrycode: 'SC',
        emergencynumber: '999'
    },
    {
        countryname: 'Christmas Island',
        phonecode: '61',
        countrycode: 'CX'
    },
    {
        countryname: 'Curacao',
        phonecode: '599',
        countrycode: 'CW',
        emergencynumber: '444444'
    },
    {
        countryname: 'Sweden',
        phonecode: '46',
        countrycode: 'SE',
        emergencynumber: '112'
    },
    {
        countryname: 'Saint Helena',
        phonecode: '290',
        countrycode: 'SH',
        emergencynumber: '911'
    },
    {
        countryname: 'Cape Verde',
        phonecode: '238',
        countrycode: 'CV',
        emergencynumber: '132'
    },
    {
        countryname: 'Cuba',
        phonecode: '53',
        countrycode: 'CU',
        emergencynumber: '106'
    },
    {
        countryname: 'Singapore',
        phonecode: '65',
        countrycode: 'SG',
        emergencynumber: '999'
    },
    {
        countryname: 'Svalbard and Jan Mayen',
        phonecode: '47',
        countrycode: 'SJ'
    },
    {
        countryname: 'Slovenia',
        phonecode: '386',
        countrycode: 'SI',
        emergencynumber: '113'
    },
    {
        countryname: 'Sierra Leone',
        phonecode: '232',
        countrycode: 'SL',
        emergencynumber: '999'
    },
    {
        countryname: 'Slovakia',
        phonecode: '421',
        countrycode: 'SK',
        emergencynumber: '112'
    },
    {
        countryname: 'Senegal',
        phonecode: '221',
        countrycode: 'SN'
    },
    {
        countryname: 'San Marino',
        phonecode: '378',
        countrycode: 'SM',
        emergencynumber: '113'
    },
    {
        countryname: 'Somalia',
        phonecode: '252',
        countrycode: 'SO',
        emergencynumber: '888'
    },
    {
        countryname: 'Suriname',
        phonecode: '597',
        countrycode: 'SR',
        emergencynumber: '115'
    },
    {
        countryname: 'Ivory Coast',
        phonecode: '225',
        countrycode: 'CI'
    },
    {
        countryname: 'Serbia',
        phonecode: '381',
        countrycode: 'RS',
        emergencynumber: '112'
    },
    {
        countryname: 'Republic of the Congo',
        phonecode: '242',
        countrycode: 'CG'
    },
    {
        countryname: 'Russia',
        phonecode: '7',
        countrycode: 'RU',
        emergencynumber: '112'
    },
    {
        countryname: 'Switzerland',
        phonecode: '41',
        countrycode: 'CH',
        emergencynumber: '112'
    },
    {
        countryname: 'Rwanda',
        phonecode: '250',
        countrycode: 'RW',
        emergencynumber: '112'
    },
    {
        countryname: 'Central African Republic',
        phonecode: '236',
        countrycode: 'CF'
    },
    {
        countryname: 'Cocos Islands',
        phonecode: '61',
        countrycode: 'CC'
    },
    {
        countryname: 'Democratic Republic of the Congo',
        phonecode: '243',
        countrycode: 'CD'
    },
    {
        countryname: 'Costa Rica',
        phonecode: '506',
        countrycode: 'CR',
        emergencynumber: '911'
    },
    {
        countryname: 'Colombia',
        phonecode: '57',
        countrycode: 'CO',
        emergencynumber: '123'
    },
    {
        countryname: 'Cameroon',
        phonecode: '237',
        countrycode: 'CM'
    },
    {
        countryname: 'China',
        phonecode: '86',
        countrycode: 'CN',
        emergencynumber: '110'
    },
    {
        countryname: 'Saudi Arabia',
        phonecode: '966',
        countrycode: 'SA',
        emergencynumber: '999'
    },
    {
        countryname: 'Cook Islands',
        phonecode: '682',
        countrycode: 'CK',
        emergencynumber: '999'
    },
    {
        countryname: 'Solomon Islands',
        phonecode: '677',
        countrycode: 'SB',
        emergencynumber: '999'
    },
    {
        countryname: 'Chile',
        phonecode: '56',
        countrycode: 'CL',
        emergencynumber: '133'
    },
    {
        countryname: 'Latvia',
        phonecode: '371',
        countrycode: 'LV',
        emergencynumber: '112'
    },
    {
        countryname: 'Luxembourg',
        phonecode: '352',
        countrycode: 'LU',
        emergencynumber: '112'
    },
    {
        countryname: 'Lithuania',
        phonecode: '370',
        countrycode: 'LT',
        emergencynumber: '112'
    },
    {
        countryname: 'Libya',
        phonecode: '218',
        countrycode: 'LY',
        emergencynumber: '193'
    },
    {
        countryname: 'Lesotho',
        phonecode: '266',
        countrycode: 'LS',
        emergencynumber: '123'
    },
    {
        countryname: 'Liberia',
        phonecode: '231',
        countrycode: 'LR',
        emergencynumber: '911'
    },
    {
        countryname: 'Madagascar',
        phonecode: '261',
        countrycode: 'MG',
        emergencynumber: '117'
    },
    {
        countryname: 'Marshall Islands',
        phonecode: '692',
        countrycode: 'MH'
    },
    {
        countryname: 'Montenegro',
        phonecode: '382',
        countrycode: 'ME',
        emergencynumber: '112'
    },
    {
        countryname: 'Saint Martin',
        phonecode: '590',
        countrycode: 'MF'
    },
    {
        countryname: 'Macedonia',
        phonecode: '389',
        countrycode: 'MK',
        emergencynumber: '112'
    },
    {
        countryname: 'Mali',
        phonecode: '223',
        countrycode: 'ML'
    },
    {
        countryname: 'Monaco',
        phonecode: '377',
        countrycode: 'MC',
        emergencynumber: '112'
    },
    {
        countryname: 'Moldova',
        phonecode: '373',
        countrycode: 'MD',
        emergencynumber: '112'
    },
    {
        countryname: 'Morocco',
        phonecode: '212',
        countrycode: 'MA',
        emergencynumber: '19'
    },
    {
        countryname: 'Maldives',
        phonecode: '960',
        countrycode: 'MV',
        emergencynumber: '119'
    },
    {
        countryname: 'Mauritius',
        phonecode: '230',
        countrycode: 'MU',
        emergencynumber: '999'
    },
    {
        countryname: 'Mexico',
        phonecode: '52',
        countrycode: 'MX',
        emergencynumber: '066'
    },
    {
        countryname: 'Malawi',
        phonecode: '265',
        countrycode: 'MW',
        emergencynumber: '997'
    },
    {
        countryname: 'Mozambique',
        phonecode: '258',
        countrycode: 'MZ',
        emergencynumber: '119'
    },
    {
        countryname: 'Malaysia',
        phonecode: '60',
        countrycode: 'MY',
        emergencynumber: '999'
    },
    {
        countryname: 'Mongolia',
        phonecode: '976',
        countrycode: 'MN',
        emergencynumber: '102'
    },
    {
        countryname: 'Myanmar',
        phonecode: '95',
        countrycode: 'MM'
    },
    {
        countryname: 'Northern Mariana Islands',
        phonecode: '1',
        countrycode: 'MP'
    },
    {
        countryname: 'Macao',
        phonecode: '853',
        countrycode: 'MO'
    },
    {
        countryname: 'Mauritania',
        phonecode: '222',
        countrycode: 'MR',
        emergencynumber: '117'
    },
    {
        countryname: 'Martinique',
        phonecode: '596',
        countrycode: 'MQ',
        emergencynumber: '17'
    },
    {
        countryname: 'Malta',
        phonecode: '356',
        countrycode: 'MT',
        emergencynumber: '112'
    },
    {
        countryname: 'Montserrat',
        phonecode: '1',
        countrycode: 'MS',
        emergencynumber: '999'
    },
    {
        countryname: 'Norfolk Island',
        phonecode: '672',
        countrycode: 'NF'
    },
    {
        countryname: 'Nigeria',
        phonecode: '234',
        countrycode: 'NG',
        emergencynumber: '199'
    },
    {
        countryname: 'Nicaragua',
        phonecode: '505',
        countrycode: 'NI',
        emergencynumber: '118'
    },
    {
        countryname: 'Netherlands',
        phonecode: '31',
        countrycode: 'NL',
        emergencynumber: '112'
    },
    {
        countryname: 'Namibia',
        phonecode: '264',
        countrycode: 'NA'
    },
    {
        countryname: 'New Caledonia',
        phonecode: '687',
        countrycode: 'NC',
        emergencynumber: '17'
    },
    {
        countryname: 'Niger',
        phonecode: '227',
        countrycode: 'NE'
    },
    {
        countryname: 'New Zealand',
        phonecode: '64',
        countrycode: 'NZ',
        emergencynumber: '111'
    },
    {
        countryname: 'Niue',
        phonecode: '683',
        countrycode: 'NU'
    },
    {
        countryname: 'Nauru',
        phonecode: '674',
        countrycode: 'NR'
    },
    {
        countryname: 'Nepal',
        phonecode: '977',
        countrycode: 'NP',
        emergencynumber: '100'
    },
    {
        countryname: 'Norway',
        phonecode: '47',
        countrycode: 'NO',
        emergencynumber: '112'
    },
    {
        countryname: 'Oman',
        phonecode: '968',
        countrycode: 'OM',
        emergencynumber: '999'
    },
    {
        countryname: 'Poland',
        phonecode: '48',
        countrycode: 'PL',
        emergencynumber: '112'
    },
    {
        countryname: 'Saint Pierre and Miquelon',
        phonecode: '508',
        countrycode: 'PM',
        emergencynumber: '17'
    },
    {
        countryname: 'Pitcairn',
        phonecode: '870',
        countrycode: 'PN'
    },
    {
        countryname: 'Philippines',
        phonecode: '63',
        countrycode: 'PH',
        emergencynumber: '117'
    },
    {
        countryname: 'Pakistan',
        phonecode: '92',
        countrycode: 'PK',
        emergencynumber: '15'
    },
    {
        countryname: 'Peru',
        phonecode: '51',
        countrycode: 'PE',
        emergencynumber: '105'
    },
    {
        countryname: 'French Polynesia',
        phonecode: '689',
        countrycode: 'PF',
        emergencynumber: '17'
    },
    {
        countryname: 'Papua New Guinea',
        phonecode: '675',
        countrycode: 'PG'
    },
    {
        countryname: 'Panama',
        phonecode: '507',
        countrycode: 'PA',
        emergencynumber: '911'
    },
    {
        countryname: 'Hong Kong',
        phonecode: '852',
        countrycode: 'HK',
        emergencynumber: '999'
    },
    {
        countryname: 'South Africa',
        phonecode: '27',
        countrycode: 'ZA',
        emergencynumber: '10111'
    },
    {
        countryname: 'Honduras',
        phonecode: '504',
        countrycode: 'HN',
        emergencynumber: '199'
    },
    {
        countryname: 'Croatia',
        phonecode: '385',
        countrycode: 'HR',
        emergencynumber: '112'
    },
    {
        countryname: 'Haiti',
        phonecode: '509',
        countrycode: 'HT',
        emergencynumber: '114'
    },
    {
        countryname: 'Hungary',
        phonecode: '36',
        countrycode: 'HU',
        emergencynumber: '112'
    },
    {
        countryname: 'Zambia',
        phonecode: '260',
        countrycode: 'ZM',
        emergencynumber: '999'
    },
    {
        countryname: 'Indonesia',
        phonecode: '62',
        countrycode: 'ID',
        emergencynumber: '110'
    },
    {
        countryname: 'Zimbabwe',
        phonecode: '263',
        countrycode: 'ZW',
        emergencynumber: '999'
    },
    {
        countryname: 'Ireland',
        phonecode: '353',
        countrycode: 'IE',
        emergencynumber: '112'
    },
    {
        countryname: 'Israel',
        phonecode: '972',
        countrycode: 'IL',
        emergencynumber: '100'
    },
    {
        countryname: 'Isle of Man',
        phonecode: '44',
        countrycode: 'IM',
        emergencynumber: '999'
    },
    {
        countryname: 'India',
        phonecode: '91',
        countrycode: 'IN',
        emergencynumber: '100'
    },
    {
        countryname: 'British Indian Ocean Territory',
        phonecode: '246',
        countrycode: 'IO'
    },
    {
        countryname: 'Iraq',
        phonecode: '964',
        countrycode: 'IQ'
    },
    {
        countryname: 'Iran',
        phonecode: '98',
        countrycode: 'IR',
        emergencynumber: '110'
    },
    {
        countryname: 'Iceland',
        phonecode: '354',
        countrycode: 'IS',
        emergencynumber: '112'
    },
    {
        countryname: 'Yemen',
        phonecode: '967',
        countrycode: 'YE'
    },
    {
        countryname: 'Italy',
        phonecode: '39',
        countrycode: 'IT',
        emergencynumber: '112'
    },
    {
        countryname: 'Jersey',
        phonecode: '44',
        countrycode: 'JE',
        emergencynumber: '112'
    },
    {
        countryname: 'Mayotte',
        phonecode: '262',
        countrycode: 'YT'
    },
    {
        countryname: 'Japan',
        phonecode: '81',
        countrycode: 'JP',
        emergencynumber: '110'
    },
    {
        countryname: 'Jordan',
        phonecode: '962',
        countrycode: 'JO'
    },
    {
        countryname: 'Jamaica',
        phonecode: '1',
        countrycode: 'JM',
        emergencynumber: '119'
    },
    {
        countryname: 'Kiribati',
        phonecode: '686',
        countrycode: 'KI',
        emergencynumber: '999'
    },
    {
        countryname: 'Cambodia',
        phonecode: '855',
        countrycode: 'KH',
        emergencynumber: '117'
    },
    {
        countryname: 'Kyrgyzstan',
        phonecode: '996',
        countrycode: 'KG',
        emergencynumber: '102'
    },
    {
        countryname: 'Kenya',
        phonecode: '254',
        countrycode: 'KE',
        emergencynumber: '999'
    },
    {
        countryname: 'North Korea',
        phonecode: '850',
        countrycode: 'KP'
    },
    {
        countryname: 'South Korea',
        phonecode: '82',
        countrycode: 'KR',
        emergencynumber: '112'
    },
    {
        countryname: 'Comoros',
        phonecode: '269',
        countrycode: 'KM',
        emergencynumber: '17'
    },
    {
        countryname: 'Saint Kitts and Nevis',
        phonecode: '1',
        countrycode: 'KN',
        emergencynumber: '911'
    },
    {
        countryname: 'Kuwait',
        phonecode: '965',
        countrycode: 'KW',
        emergencynumber: '112'
    },
    {
        countryname: 'Cayman Islands',
        phonecode: '1',
        countrycode: 'KY',
        emergencynumber: '911'
    },
    {
        countryname: 'Kazakhstan',
        phonecode: '7',
        countrycode: 'KZ',
        emergencynumber: '112'
    },
    {
        countryname: 'Laos',
        phonecode: '856',
        countrycode: 'LA',
        emergencynumber: '191'
    },
    {
        countryname: 'Saint Lucia',
        phonecode: '1',
        countrycode: 'LC',
        emergencynumber: '911'
    },
    {
        countryname: 'Lebanon',
        phonecode: '961',
        countrycode: 'LB',
        emergencynumber: '112'
    },
    {
        countryname: 'Liechtenstein',
        phonecode: '423',
        countrycode: 'LI',
        emergencynumber: '112'
    },
    {
        countryname: 'Sri Lanka',
        phonecode: '94',
        countrycode: 'LK',
        emergencynumber: '119'
    }
];

const COUNTRIES_ASSET_PATH = new InjectionToken('COUNTRIES_ASSET_PATH');

class CountriesService {
    constructor(http, countryPath) {
        this.http = http;
        this.countryPath = countryPath;
    }
    /**
     * Get a list of countires and their contry and dialing codes
     */
    getCountries() {
        if (!this.countries) {
            const retSubject = new Subject();
            this.countries = retSubject.asObservable();
            this.fetchCountries()
                .pipe(tap(list => {
                retSubject.next(list);
                retSubject.complete();
                this.countries = of(list);
            }))
                .subscribe();
        }
        return this.countries;
    }
    /**
     * get a country by its country code
     *
     * @param code - the country code to get details for
     */
    getCountryByCode(code) {
        return this.getCountries().pipe(map(cs => cs.find(c => c.countrycode === code)));
    }
    /**
     * fetch a list of countries
     */
    fetchCountries() {
        return this.countryPath
            ? this.http.get(this.countryPath)
            : of(DefaultCountryList);
    }
}
CountriesService.ɵfac = function CountriesService_Factory(t) { return new (t || CountriesService)(ɵngcc0.ɵɵinject(ɵngcc9.HttpClient), ɵngcc0.ɵɵinject(COUNTRIES_ASSET_PATH)); };
CountriesService.ɵprov = ɵɵdefineInjectable({ factory: function CountriesService_Factory() { return new CountriesService(ɵɵinject(HttpClient), ɵɵinject(COUNTRIES_ASSET_PATH)); }, token: CountriesService, providedIn: "root" });
CountriesService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Inject, args: [COUNTRIES_ASSET_PATH,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CountriesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc9.HttpClient }, { type: String, decorators: [{
                type: Inject,
                args: [COUNTRIES_ASSET_PATH]
            }] }]; }, null); })();

class PhoneFieldComponent {
    constructor(cs) {
        this.cs = cs;
        this.value = {
            number: null,
            regionCode: 'US',
            dialingCode: null
        };
        this.disabled = false;
        this.readonly = false;
        this.change = new EventEmitter();
        this.form = new FormGroup({
            regionCode: new FormControl(null, [Validators.required]),
            number: new FormControl(null, [
                Validators.required,
                Validators.pattern(/[0-9]+/),
                Validators.minLength(6)
            ])
        });
        this.countries = this.cs.getCountries().pipe(map(list => list.sort((a, b) => a.countryname.toLowerCase() < b.countryname.toLowerCase() ? -1 : 1)), tap(list => {
            const usIndex = list.findIndex(elm => elm.countrycode === 'US');
            list.unshift(list.splice(usIndex, 1)[0]);
        }));
        this.propagateChange = (_) => { };
        this.formSubscription = this.form.valueChanges.subscribe(value => {
            this.cs.getCountryByCode(value.regionCode).subscribe(ans => {
                this.value.dialingCode = ans ? ans.phonecode : null;
                this.value.number = value.number;
                this.value.regionCode = value.regionCode;
                this.propagateChange(this.value);
                this.change.emit(this.value);
            });
        });
    }
    writeValue(data = {}) {
        this.form.setValue({
            regionCode: data ? data.regionCode : null,
            number: data ? data.number : null
        });
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched() { }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    validate(c) {
        return this.form.valid
            ? null
            : {
                phoneError: {
                    valid: false
                }
            };
    }
    ngOnDestroy() {
        this.formSubscription.unsubscribe();
    }
}
PhoneFieldComponent.ɵfac = function PhoneFieldComponent_Factory(t) { return new (t || PhoneFieldComponent)(ɵngcc0.ɵɵdirectiveInject(CountriesService)); };
PhoneFieldComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PhoneFieldComponent, selectors: [["mat-phone-field"]], inputs: { value: "value", disabled: "disabled", readonly: "readonly" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => PhoneFieldComponent),
                multi: true
            },
            {
                provide: NG_VALIDATORS,
                useExisting: forwardRef(() => PhoneFieldComponent),
                multi: true
            }
        ])], decls: 11, vars: 5, consts: [[3, "formGroup"], ["appearance", "outline", 1, "country-control"], ["livesafeMat", "", "name", "countryCode", "formControlName", "regionCode"], [4, "ngIf"], [3, "value", 4, "ngFor", "ngForOf"], ["appearance", "outline"], ["matInput", "", "type", "text", "formControlName", "number", "name", "phoneNumber"], [3, "value"]], template: function PhoneFieldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵelementStart(1, "mat-form-field", 1);
        ɵngcc0.ɵɵelementStart(2, "mat-select", 2);
        ɵngcc0.ɵɵtemplate(3, PhoneFieldComponent_mat_select_trigger_3_Template, 2, 1, "mat-select-trigger", 3);
        ɵngcc0.ɵɵtemplate(4, PhoneFieldComponent_mat_option_4_Template, 2, 2, "mat-option", 4);
        ɵngcc0.ɵɵpipe(5, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(6, "div");
        ɵngcc0.ɵɵelementStart(7, "mat-form-field", 5);
        ɵngcc0.ɵɵelementStart(8, "mat-label");
        ɵngcc0.ɵɵtext(9, "Phone Number");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(10, "input", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.value.dialingCode);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(5, 3, ctx.countries));
    } }, directives: [ɵngcc10.ɵangular_packages_forms_forms_y, ɵngcc10.NgControlStatusGroup, ɵngcc10.FormGroupDirective, ɵngcc2.MatFormField, ɵngcc11.MatSelect, ɵngcc3.LiveSafeMatDirective, ɵngcc10.NgControlStatus, ɵngcc10.FormControlName, ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc2.MatLabel, ɵngcc5.MatInput, ɵngcc10.DefaultValueAccessor, ɵngcc11.MatSelectTrigger, ɵngcc7.MatOption], pipes: [ɵngcc1.AsyncPipe], styles: ["form[_ngcontent-%COMP%]{display:flex;flex-direction:row}form[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{margin-right:16px}form[_ngcontent-%COMP%] > .country-control[_ngcontent-%COMP%]{max-width:80px;min-width:0}"], changeDetection: 0 });
PhoneFieldComponent.ctorParameters = () => [
    { type: CountriesService }
];
PhoneFieldComponent.propDecorators = {
    value: [{ type: Input }],
    disabled: [{ type: Input }],
    readonly: [{ type: Input }],
    change: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PhoneFieldComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line: component-selector
                selector: 'mat-phone-field',
                template: "<form [formGroup]=\"form\">\n  <mat-form-field appearance=\"outline\" class=\"country-control\">\n    <mat-select livesafeMat name=\"countryCode\" formControlName=\"regionCode\">\n      <mat-select-trigger *ngIf=\"value.dialingCode\">+{{ value.dialingCode}}</mat-select-trigger>\n      <mat-option *ngFor=\"let country of countries | async\" [value]=\"country.countrycode\">\n        {{country.countryname + ' +' + country.phonecode}}\n      </mat-option>\n    </mat-select>\n  </mat-form-field>\n  <div></div>\n  <mat-form-field appearance=\"outline\">\n    <mat-label>Phone Number</mat-label>\n    <input matInput type=\"text\" formControlName=\"number\" name=\"phoneNumber\" />\n  </mat-form-field>\n</form>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => PhoneFieldComponent),
                        multi: true
                    },
                    {
                        provide: NG_VALIDATORS,
                        useExisting: forwardRef(() => PhoneFieldComponent),
                        multi: true
                    }
                ],
                styles: ["form{display:flex;flex-direction:row}form>div{margin-right:16px}form>.country-control{max-width:80px;min-width:0}"]
            }]
    }], function () { return [{ type: CountriesService }]; }, { value: [{
            type: Input
        }], disabled: [{
            type: Input
        }], readonly: [{
            type: Input
        }], change: [{
            type: Output
        }] }); })();

class ColorPickerComponent {
    constructor() {
        this.colors = ColorPickerComponent.DEFAULT_PALETTE;
        /* tslint:disable-next-line:no-input-rename */
        this.valueType = 'palette';
        this.valueChange = new EventEmitter();
        this.color = new FormControl(null);
        this.destroy$ = new Subject();
        this.propagateChange = (_) => { };
    }
    set value(color) { this.writeValue(color); }
    set disabled(disabled) { this.setDisabledState(disabled); }
    writeValue(color) { this.color.setValue(color); }
    registerOnChange(fn) { this.propagateChange = fn; }
    registerOnTouched() { }
    setDisabledState(disabled) { disabled ? this.color.disable() : this.color.enable(); }
    ngOnInit() {
        if (this.valueType === 'hex') {
            this.colors = Object.values(ColorPickerComponent.HEX_MAP);
        }
        this.color.valueChanges
            .pipe(takeUntil(this.destroy$), tap(res => {
            this.propagateChange(res);
            this.valueChange.emit(res);
        }))
            .subscribe();
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
ColorPickerComponent.ɵfac = function ColorPickerComponent_Factory(t) { return new (t || ColorPickerComponent)(); };
ColorPickerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ColorPickerComponent, selectors: [["color-picker"]], inputs: { colors: "colors", valueType: "valueType", value: "value", disabled: "disabled" }, outputs: { valueChange: "valueChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => ColorPickerComponent),
                multi: true
            }
        ])], decls: 3, vars: 3, consts: [[3, "formControl"], [4, "ngIf"], [3, "class", "value", 4, "ngFor", "ngForOf"], [3, "value"], [3, "backgroundColor", "value", 4, "ngFor", "ngForOf"]], template: function ColorPickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-radio-group", 0);
        ɵngcc0.ɵɵtemplate(1, ColorPickerComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(2, ColorPickerComponent_ng_container_2_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formControl", ctx.color);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.valueType === "palette");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.valueType === "hex");
    } }, directives: [ɵngcc12.MatRadioGroup, ɵngcc10.NgControlStatus, ɵngcc10.FormControlDirective, ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc12.MatRadioButton], styles: ["[_nghost-%COMP%]     .mat-radio-group .mat-radio-button{border-radius:2px;margin:0 12px 12px 0}[_nghost-%COMP%]     .mat-radio-group .mat-radio-container{height:24px!important;width:24px!important}[_nghost-%COMP%]     .mat-radio-group .mat-radio-inner-circle, [_nghost-%COMP%]     .mat-radio-group .mat-radio-label-content, [_nghost-%COMP%]     .mat-radio-group .mat-radio-outer-circle{display:none!important}"], changeDetection: 0 });
ColorPickerComponent.DEFAULT_PALETTE = [
    'persimmon', 'macandcheese', 'mustard', 'brightgreen', 'aquamarine', 'dodgerblue', 'heliotrope',
    'hotpink', 'iron', 'tamarillo', 'neoncarrot', 'equator', 'lima', 'elfgreen', 'sttropez',
    'minsk', 'redviolet', 'martinique'
];
ColorPickerComponent.HEX_MAP = {
    persimmon: '#ff5b5b',
    macandcheese: '#ffc975',
    mustard: '#ffee7a',
    brightgreen: '#8eff5b',
    aquamarine: '#5bffe0',
    dodgerblue: '#5b8bff',
    heliotrope: '#8e5bff',
    hotpink: '#ff5ba8',
    iron: '#cfd1d2',
    tamarillo: '#a51e1e',
    neoncarrot: '#ff8a40',
    equator: '#eec04c',
    lima: '#4ec521',
    elfgreen: '#059076',
    sttropez: '#21469f',
    minsk: '#4f26a8',
    redviolet: '#da1472',
    martinique: '#32354d'
};
ColorPickerComponent.propDecorators = {
    colors: [{ type: Input }],
    value: [{ type: Input, args: ['value',] }],
    disabled: [{ type: Input, args: ['disabled',] }],
    valueType: [{ type: Input, args: ['valueType',] }],
    valueChange: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ColorPickerComponent, [{
        type: Component,
        args: [{
                /* tslint:disable-next-line:component-selector */
                selector: 'color-picker',
                template: "<mat-radio-group [formControl]=\"color\">\n  <ng-container *ngIf=\"valueType === 'palette'\">\n    <mat-radio-button *ngFor=\"let i of colors\" class=\"rainbow-background-{{i}}\" [value]=\"i\"></mat-radio-button>\n  </ng-container>\n  <ng-container *ngIf=\"valueType === 'hex'\">\n    <mat-radio-button *ngFor=\"let i of colors\" [style.backgroundColor]=\"i\" [value]=\"i\"></mat-radio-button>\n  </ng-container>\n</mat-radio-group>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => ColorPickerComponent),
                        multi: true
                    }
                ],
                styles: [":host ::ng-deep .mat-radio-group .mat-radio-button{border-radius:2px;margin:0 12px 12px 0}:host ::ng-deep .mat-radio-group .mat-radio-container{height:24px!important;width:24px!important}:host ::ng-deep .mat-radio-group .mat-radio-inner-circle,:host ::ng-deep .mat-radio-group .mat-radio-label-content,:host ::ng-deep .mat-radio-group .mat-radio-outer-circle{display:none!important}"]
            }]
    }], function () { return []; }, { colors: [{
            type: Input
        }], valueType: [{
            type: Input,
            args: ['valueType']
        }], valueChange: [{
            type: Output
        }], value: [{
            type: Input,
            args: ['value']
        }], disabled: [{
            type: Input,
            args: ['disabled']
        }] }); })();

class AlertDialogComponent {
    constructor(data) {
        this.data = data;
    }
}
AlertDialogComponent.ɵfac = function AlertDialogComponent_Factory(t) { return new (t || AlertDialogComponent)(ɵngcc0.ɵɵdirectiveInject(MAT_DIALOG_DATA, 8)); };
AlertDialogComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AlertDialogComponent, selectors: [["livesafe-alert-dialog"]], decls: 4, vars: 6, consts: [["mat-dialog-title", "", "align", "center", 4, "ngIf"], ["mat-dialog-content", "", "align", "center", 3, "innerHTML"], ["mat-dialog-actions", "", "align", "center"], ["livesafeMat", "", "mat-raised-button", "", 3, "color", "mat-dialog-close", 4, "ngFor", "ngForOf"], ["mat-dialog-title", "", "align", "center"], ["livesafeMat", "", "mat-raised-button", "", 3, "color", "mat-dialog-close"]], template: function AlertDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AlertDialogComponent_div_0_Template, 2, 1, "div", 0);
        ɵngcc0.ɵɵelement(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, AlertDialogComponent_button_3_Template, 2, 3, "button", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.data == null ? null : ctx.data.header);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.data == null ? null : ctx.data.message, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", (ctx.data == null ? null : ctx.data.buttons) || ɵngcc0.ɵɵpureFunction1(4, _c4, ɵngcc0.ɵɵpureFunction0(3, _c3)));
    } }, directives: [ɵngcc1.NgIf, ɵngcc13.MatDialogContent, ɵngcc13.MatDialogActions, ɵngcc1.NgForOf, ɵngcc13.MatDialogTitle, ɵngcc8.MatButton, ɵngcc3.LiveSafeMatDirective, ɵngcc13.MatDialogClose], encapsulation: 2 });
AlertDialogComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [MAT_DIALOG_DATA,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AlertDialogComponent, [{
        type: Component,
        args: [{
                selector: 'livesafe-alert-dialog',
                template: "<div mat-dialog-title *ngIf=\"data?.header\" align=\"center\">{{data?.header}}</div>\n<div mat-dialog-content align=\"center\" [innerHTML]=\"data?.message\"></div>\n<div mat-dialog-actions align=\"center\">\n  <button\n    *ngFor=\"let btn of (data?.buttons || [{ label: 'Ok' }])\"\n    livesafeMat\n    mat-raised-button\n    [color]=\"btn.color || 'primary'\"\n    [mat-dialog-close]=\"btn.value\">{{ btn.label }}\n  </button>\n</div>\n"
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

class ChatComponent {
    constructor($breakpoint) {
        this.$breakpoint = $breakpoint;
        this.admin = false;
        this.first = false;
        this.loading = false;
        this.name = null;
        this.time = null;
        this.location = null;
        this.topic = null;
        this.expand = new EventEmitter();
        this.saveTopic = new EventEmitter();
        this.mobile = false;
        this.unsubscribe$ = new Subject();
        this.edit = false;
    }
    ngOnInit() {
        this.$breakpoint
            .observe([
            Breakpoints.XSmall,
            Breakpoints.Small
        ])
            .pipe(takeUntil(this.unsubscribe$), tap((state) => {
            this.mobile = state.matches;
        }))
            .subscribe();
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
    updateTopic({ target }) {
        this.saveTopic.emit(target.value);
        this.edit = false;
    }
    focusField() {
        if (!this.admin) {
            this.edit = true;
            setTimeout(() => this.topicInput.nativeElement.focus(), 200);
        }
    }
}
ChatComponent.ɵfac = function ChatComponent_Factory(t) { return new (t || ChatComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc14.BreakpointObserver)); };
ChatComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ChatComponent, selectors: [["livesafe-chat"]], viewQuery: function ChatComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c5, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.topicInput = _t.first);
    } }, hostVars: 8, hostBindings: function ChatComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("admin", ctx.admin)("first", ctx.first)("loading", ctx.loading)("mobile", ctx.mobile);
    } }, inputs: { admin: "admin", first: "first", loading: "loading", name: "name", time: "time", location: "location", topic: "topic" }, outputs: { expand: "expand", saveTopic: "saveTopic" }, ngContentSelectors: _c7, decls: 8, vars: 10, consts: [["class", "sender", 4, "ngIf"], [1, "cdk-visually-hidden"], [1, "message-container"], [1, "sender"], [3, "title", "click"], ["appearance", "outline", 4, "ngIf"], ["class", "mat-body-strong onsurface-700 to-ellipsis", 4, "ngIf"], ["appearance", "outline"], ["matInput", "", "maxlength", "50", 3, "value", "blur", "keydown.enter"], ["topicInput", ""], [1, "mat-body-strong", "onsurface-700", "to-ellipsis"], [1, "name", "mat-body-strong"], ["class", "time mat-body", "timeago", "", 3, "date", 4, "ngIf"], ["timeago", "", 1, "time", "mat-body", 3, "date"]], template: function ChatComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c6);
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, ChatComponent_div_1_Template, 9, 10, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "span", 1);
        ɵngcc0.ɵɵtext(3, "message:\u00A0");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵprojection(6, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, ChatComponent_div_7_Template, 6, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("message ", ctx.admin ? "onsurface-background-100" : "primary-background-200", "");
        ɵngcc0.ɵɵclassProp("no-location", !ctx.location)("first", ctx.first);
        ɵngcc0.ɵɵattribute("data-location", ctx.location);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.first);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.first);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.MatFormField, ɵngcc5.MatInput, ɵngcc15.TimeagoDirective], styles: ["[_nghost-%COMP%]{align-items:end;display:grid;grid-column-gap:24px;grid-row-gap:8px;grid-template-areas:\"left center right\";grid-template-columns:minmax(100px,1fr) minmax(auto,640px) minmax(100px,1fr);grid-template-rows:auto;margin-bottom:24px;transition:opacity .25s ease-in-out}[_nghost-%COMP%]   .message[_ngcontent-%COMP%]{-ms-grid-column:3;-ms-grid-row:1;grid-area:center;justify-self:end}[_nghost-%COMP%]   .sender[_ngcontent-%COMP%]{-ms-grid-column:5;-ms-grid-row:1;grid-area:right;position:relative}[_nghost-%COMP%]   .sender[_ngcontent-%COMP%]   .header.edit-mode[_ngcontent-%COMP%]{height:100px}.admin[_nghost-%COMP%]{grid-template-areas:\"left center right\";grid-template-columns:minmax(100px,1fr) minmax(auto,640px) minmax(100px,1fr)}.admin[_nghost-%COMP%]   .message.no-location[_ngcontent-%COMP%]{justify-self:start}.admin[_nghost-%COMP%]   .sender[_ngcontent-%COMP%]{-ms-grid-column:1;-ms-grid-row:1;grid-area:left;text-align:right}.loading[_nghost-%COMP%]{opacity:.5}.mobile[_nghost-%COMP%]{grid-template-areas:\"top\" \"bottom\"!important;grid-template-columns:100%!important;grid-template-rows:auto auto!important}.mobile[_nghost-%COMP%]   .message[_ngcontent-%COMP%]{-ms-grid-column:1;-ms-grid-row:1;grid-area:top;justify-self:end}.mobile[_nghost-%COMP%]   .sender[_ngcontent-%COMP%]{text-align:right}.mobile.first[_nghost-%COMP%]   .message[_ngcontent-%COMP%], .mobile[_nghost-%COMP%]   .sender[_ngcontent-%COMP%]{-ms-grid-column:1;-ms-grid-row:2;grid-area:bottom}.mobile.first[_nghost-%COMP%]   .message[_ngcontent-%COMP%]{justify-self:stretch}.mobile.first[_nghost-%COMP%]   .sender[_ngcontent-%COMP%]{-ms-grid-column:1;-ms-grid-row:1;grid-area:top;text-align:left}.mobile.admin[_nghost-%COMP%]   .message[_ngcontent-%COMP%]{-ms-grid-column:1;-ms-grid-row:1;grid-area:top;justify-self:start}.mobile.admin[_nghost-%COMP%]   .sender[_ngcontent-%COMP%]{-ms-grid-column:1;-ms-grid-row:2;grid-area:bottom;text-align:left}[_nghost-%COMP%]   .message[_ngcontent-%COMP%]{border-radius:16px 16px 0 16px;color:#fff;font-size:14px;font-weight:700;line-height:27px;padding:6px;position:relative}[_nghost-%COMP%]   .message[_ngcontent-%COMP%]:not(.first){max-width:400px}[_nghost-%COMP%]   .message[_ngcontent-%COMP%]   .message-container[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;justify-content:space-between;word-break:break-word}[_nghost-%COMP%]   .sender[_ngcontent-%COMP%]   .name[_ngcontent-%COMP%]{font-weight:700;word-break:break-word}[_nghost-%COMP%]   .sender[_ngcontent-%COMP%]   .time[_ngcontent-%COMP%]{display:block;overflow:hidden;white-space:nowrap}.first[_nghost-%COMP%]   .message[_ngcontent-%COMP%]{background-color:#fff;border-radius:16px;box-shadow:0 13px 40px 0 rgba(22,32,38,.12);width:100%}.first[_nghost-%COMP%]   mat-form-field[_ngcontent-%COMP%]{position:absolute;top:33px;width:100%}.first[_nghost-%COMP%]   .topic[_ngcontent-%COMP%]{margin-top:0!important;word-wrap:break-word}.first[_nghost-%COMP%]   .topic.edit-mode[_ngcontent-%COMP%]{visibility:hidden}.admin[_nghost-%COMP%]   .message[_ngcontent-%COMP%]{border-radius:16px 16px 16px 0;font-weight:400}  .message>:last-child{margin-bottom:0!important}  livesafe-map{height:172px!important;margin-bottom:8px}  livesafe-map .map-container>*{background-color:initial!important;border-radius:16px;overflow:hidden}  livesafe-media{justify-content:flex-end;margin-bottom:8px;order:3;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}  .no-location livesafe-map{pointer-events:none}  .no-location livesafe-map .gm-style{filter:blur(5px)}"], changeDetection: 0 });
ChatComponent.ctorParameters = () => [
    { type: BreakpointObserver }
];
ChatComponent.propDecorators = {
    admin: [{ type: Input }, { type: HostBinding, args: ['class.admin',] }],
    first: [{ type: Input }, { type: HostBinding, args: ['class.first',] }],
    loading: [{ type: Input }, { type: HostBinding, args: ['class.loading',] }],
    name: [{ type: Input }],
    time: [{ type: Input }],
    location: [{ type: Input }],
    topic: [{ type: Input }],
    expand: [{ type: Output }],
    saveTopic: [{ type: Output }],
    mobile: [{ type: HostBinding, args: ['class.mobile',] }],
    topicInput: [{ type: ViewChild, args: ['topicInput', { static: false },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ChatComponent, [{
        type: Component,
        args: [{
                selector: 'livesafe-chat',
                template: "<div class=\"message {{ admin ? 'onsurface-background-100' : 'primary-background-200' }}\" [class.no-location]=\"!location\" [class.first]=\"first\" [attr.data-location]=\"location\">\n  <div class=\"sender\" *ngIf=\"first\">\n    <div class=\"header {{ edit ? 'edit-mode' : '' }}\">\n      <ng-content select=\"[header]\"></ng-content>\n      <div class=\"mat-h3 topic {{ edit ? 'edit-mode' : ''}}\" [title]=\"!admin ? 'Click to Edit' : ''\" (click)=\"focusField()\">{{ topic }}</div>\n      <mat-form-field *ngIf=\"edit\" appearance=\"outline\">\n        <input matInput (blur)=\"updateTopic($event)\" (keydown.enter)=\"updateTopic($event)\" maxlength=\"50\" [value]=\"topic\" #topicInput/>\n      </mat-form-field>\n    </div>\n    <ng-content select=\"[map]\"></ng-content>\n    <div class=\"mat-body-strong onsurface-700 to-ellipsis\" *ngIf=\"location\">{{ location }}</div>\n    <ng-content select=\"[media]\"></ng-content>\n  </div>\n  <span class=\"cdk-visually-hidden\">message:&nbsp;</span>\n  <div class=\"message-container\">\n    <ng-content select=\"[message]\"></ng-content>\n    <ng-content select=\"[messageMedia]\"></ng-content>\n  </div>\n</div>\n<div class=\"sender\" *ngIf=\"!first\">\n  <div class=\"name mat-body-strong\">\n    <span class=\"cdk-visually-hidden\">submitter:&nbsp;</span>{{ (name && name.trim()) || 'Anonymous' }}\n  </div>\n  <div *ngIf=\"time\" class=\"time mat-body\" timeago [date]=\"time\"></div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{align-items:end;display:grid;grid-column-gap:24px;grid-row-gap:8px;grid-template-areas:\"left center right\";grid-template-columns:minmax(100px,1fr) minmax(auto,640px) minmax(100px,1fr);grid-template-rows:auto;margin-bottom:24px;transition:opacity .25s ease-in-out}:host .message{-ms-grid-column:3;-ms-grid-row:1;grid-area:center;justify-self:end}:host .sender{-ms-grid-column:5;-ms-grid-row:1;grid-area:right;position:relative}:host .sender .header.edit-mode{height:100px}:host.admin{grid-template-areas:\"left center right\";grid-template-columns:minmax(100px,1fr) minmax(auto,640px) minmax(100px,1fr)}:host.admin .message.no-location{justify-self:start}:host.admin .sender{-ms-grid-column:1;-ms-grid-row:1;grid-area:left;text-align:right}:host.loading{opacity:.5}:host.mobile{grid-template-areas:\"top\" \"bottom\"!important;grid-template-columns:100%!important;grid-template-rows:auto auto!important}:host.mobile .message{-ms-grid-column:1;-ms-grid-row:1;grid-area:top;justify-self:end}:host.mobile .sender{text-align:right}:host.mobile.first .message,:host.mobile .sender{-ms-grid-column:1;-ms-grid-row:2;grid-area:bottom}:host.mobile.first .message{justify-self:stretch}:host.mobile.first .sender{-ms-grid-column:1;-ms-grid-row:1;grid-area:top;text-align:left}:host.mobile.admin .message{-ms-grid-column:1;-ms-grid-row:1;grid-area:top;justify-self:start}:host.mobile.admin .sender{-ms-grid-column:1;-ms-grid-row:2;grid-area:bottom;text-align:left}:host .message{border-radius:16px 16px 0 16px;color:#fff;font-size:14px;font-weight:700;line-height:27px;padding:6px;position:relative}:host .message:not(.first){max-width:400px}:host .message .message-container{display:flex;flex-wrap:wrap;justify-content:space-between;word-break:break-word}:host .sender .name{font-weight:700;word-break:break-word}:host .sender .time{display:block;overflow:hidden;white-space:nowrap}:host.first .message{background-color:#fff;border-radius:16px;box-shadow:0 13px 40px 0 rgba(22,32,38,.12);width:100%}:host.first mat-form-field{position:absolute;top:33px;width:100%}:host.first .topic{margin-top:0!important;word-wrap:break-word}:host.first .topic.edit-mode{visibility:hidden}:host.admin .message{border-radius:16px 16px 16px 0;font-weight:400}::ng-deep .message>:last-child{margin-bottom:0!important}::ng-deep livesafe-map{height:172px!important;margin-bottom:8px}::ng-deep livesafe-map .map-container>*{background-color:initial!important;border-radius:16px;overflow:hidden}::ng-deep livesafe-media{justify-content:flex-end;margin-bottom:8px;order:3;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}::ng-deep .no-location livesafe-map{pointer-events:none}::ng-deep .no-location livesafe-map .gm-style{filter:blur(5px)}"]
            }]
    }], function () { return [{ type: ɵngcc14.BreakpointObserver }]; }, { admin: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.admin']
        }], first: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.first']
        }], loading: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.loading']
        }], name: [{
            type: Input
        }], time: [{
            type: Input
        }], location: [{
            type: Input
        }], topic: [{
            type: Input
        }], expand: [{
            type: Output
        }], saveTopic: [{
            type: Output
        }], mobile: [{
            type: HostBinding,
            args: ['class.mobile']
        }], topicInput: [{
            type: ViewChild,
            args: ['topicInput', { static: false }]
        }] }); })();

class MediaComponent {
    constructor() {
        this.media = [];
        this.selected = new EventEmitter();
    }
    onMediaClick(index) {
        this.selected.emit(index);
    }
}
MediaComponent.ɵfac = function MediaComponent_Factory(t) { return new (t || MediaComponent)(); };
MediaComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MediaComponent, selectors: [["livesafe-media"]], inputs: { media: "media" }, outputs: { selected: "selected" }, decls: 5, vars: 8, consts: [["class", "no-media", 4, "ngIf"], ["role", "button", "tabindex", "0", 3, "type", "src", "click", 4, "ngFor", "ngForOf"], ["role", "button", "tabindex", "0", 3, "type", "src", "click", 4, "ngIf"], ["class", "more-button", "role", "button", "tabindex", "0", 3, "click", 4, "ngIf"], [1, "no-media"], ["role", "button", "tabindex", "0", 3, "type", "src", "click"], ["role", "button", "tabindex", "0", 1, "more-button", 3, "click"]], template: function MediaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, MediaComponent_span_0_Template, 2, 0, "span", 0);
        ɵngcc0.ɵɵtemplate(1, MediaComponent_livesafe_image_1_Template, 1, 3, "livesafe-image", 1);
        ɵngcc0.ɵɵpipe(2, "slice");
        ɵngcc0.ɵɵtemplate(3, MediaComponent_livesafe_image_3_Template, 1, 3, "livesafe-image", 2);
        ɵngcc0.ɵɵtemplate(4, MediaComponent_span_4_Template, 2, 2, "span", 3);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.media || ctx.media.length === 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind3(2, 4, ctx.media, 0, 4));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.media.length === 5);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.media.length > 5);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc1.NgForOf, ImageComponent]; }, pipes: function () { return [ɵngcc1.SlicePipe]; }, styles: ["[_nghost-%COMP%]{display:flex;flex-direction:row;font-family:Inter,sans-serif;font-size:1rem}[_nghost-%COMP%] > [_ngcontent-%COMP%]:not(:last-child){margin-right:6px}.more-button[_ngcontent-%COMP%], livesafe-image[_ngcontent-%COMP%]{border-radius:10px;cursor:pointer;display:inline-block;height:36px;line-height:36px;overflow:hidden;position:relative;text-align:center;width:36px}.more-button[_ngcontent-%COMP%]:focus, livesafe-image[_ngcontent-%COMP%]:focus{box-shadow:0 1px 30px 0 rgba(0,0,0,.15);outline:none}.more-button[_ngcontent-%COMP%]{font-weight:700}.no-media[_ngcontent-%COMP%]{font-family:Inter,sans-serif;font-size:14px;font-weight:500;line-height:36px}"], changeDetection: 0 });
MediaComponent.propDecorators = {
    media: [{ type: Input }],
    selected: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MediaComponent, [{
        type: Component,
        args: [{
                selector: 'livesafe-media',
                template: "<span *ngIf=\"!media || media.length === 0\" class=\"no-media\">No Media</span>\n<livesafe-image\n  *ngFor=\"let entry of media | slice:0:4, index as i;\"\n  role=\"button\"\n  tabindex=\"0\"\n  [attr.aria-label]=\"'view file ' + i + ' in media modal'\"\n  [type]=\"entry.type\"\n  [src]=\"entry.src\"\n  (click)=\"onMediaClick(i)\">\n</livesafe-image>\n<livesafe-image\n  *ngIf=\"media.length === 5\"\n  role=\"button\"\n  tabindex=\"0\"\n  [attr.aria-label]=\"'view file ' + 4 + ' in media modal'\"\n  [type]=\"media[4].type\"\n  [src]=\"media[4].src\"\n  (click)=\"onMediaClick(4)\">\n</livesafe-image>\n<span\n  *ngIf=\"media.length > 5\"\n  class=\"more-button\"\n  role=\"button\"\n  tabindex=\"0\"\n  [attr.aria-label]=\"'view more media items'\"\n  (click)=\"onMediaClick(4)\">+{{media.length - 4 > 99 ? 99 : media.length - 4}}\n</span>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{display:flex;flex-direction:row;font-family:Inter,sans-serif;font-size:1rem}:host>:not(:last-child){margin-right:6px}.more-button,livesafe-image{border-radius:10px;cursor:pointer;display:inline-block;height:36px;line-height:36px;overflow:hidden;position:relative;text-align:center;width:36px}.more-button:focus,livesafe-image:focus{box-shadow:0 1px 30px 0 rgba(0,0,0,.15);outline:none}.more-button{font-weight:700}.no-media{font-family:Inter,sans-serif;font-size:14px;font-weight:500;line-height:36px}"]
            }]
    }], function () { return []; }, { media: [{
            type: Input
        }], selected: [{
            type: Output
        }] }); })();

class MediaService {
    constructor() {
        this.CONTENT_TYPE = {
            IMAGE: 'image',
            VIDEO: 'video',
            AUDIO: 'audio',
            TEXT: 'text',
            UNKNOWN: 'unknown',
            ERROR: 'error'
        };
    }
    getMediaType(contentType) {
        if (contentType.includes(this.CONTENT_TYPE.IMAGE)) {
            if (contentType.includes('tiff')) {
                return this.CONTENT_TYPE.UNKNOWN;
            }
            return this.CONTENT_TYPE.IMAGE;
        }
        if (contentType.includes(this.CONTENT_TYPE.AUDIO)) {
            return this.CONTENT_TYPE.AUDIO;
        }
        if (contentType.includes(this.CONTENT_TYPE.VIDEO)) {
            return this.CONTENT_TYPE.VIDEO;
        }
        if (['pdf', 'text'].some(i => contentType.includes(i))) {
            return this.CONTENT_TYPE.TEXT;
        }
        if (contentType.includes(this.CONTENT_TYPE.ERROR)) {
            return this.CONTENT_TYPE.ERROR;
        }
        return this.CONTENT_TYPE.UNKNOWN;
    }
    getMediaURL(userId, eventId, mediaId) {
        return `users/${userId}/events/${eventId}/media/${mediaId}/data`;
    }
    isImage(type) { return type === this.CONTENT_TYPE.IMAGE; }
    isVideo(type) { return type === this.CONTENT_TYPE.VIDEO; }
    isAudio(type) { return type === this.CONTENT_TYPE.AUDIO; }
    isText(type) { return type === this.CONTENT_TYPE.TEXT; }
    isUnknown(type) { return type === this.CONTENT_TYPE.UNKNOWN; }
    isError(type) { return type === this.CONTENT_TYPE.ERROR; }
}
MediaService.ɵfac = function MediaService_Factory(t) { return new (t || MediaService)(); };
MediaService.ɵprov = ɵɵdefineInjectable({ factory: function MediaService_Factory() { return new MediaService(); }, token: MediaService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MediaService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class ImageComponent {
    constructor($media, http, sanitizer) {
        this.$media = $media;
        this.http = http;
        this.sanitizer = sanitizer;
        this.TOOLTIP_MESSAGE = {
            VIDEO: 'Video content, no preview available.',
            AUDIO: 'Audio content, no preview available.',
            TEXT: 'Text content, no preview available.',
            UNKNOWN: 'Your media has been uploaded successfully, but we’re unable to show a preview.',
            ERROR: 'There was an error getting your media. Please try again.'
        };
        this.type = '';
        this.loading$ = new BehaviorSubject(true);
        this._src$ = new BehaviorSubject('');
        this.src$ = this._src$.pipe(filter((src) => this.type === this.$media.CONTENT_TYPE.IMAGE && !!src), switchMap((src) => this.getMedia(src)));
    }
    set src(src) {
        this._src$.next(src);
    }
    ngOnInit() {
        this.src$.subscribe();
    }
    getMedia(src) {
        this.loading$.next(true);
        return this.http.get(src, { responseType: 'blob' }).pipe(map(res => {
            const url = URL.createObjectURL(res);
            return this.sanitizer.bypassSecurityTrustResourceUrl(url);
        }), catchError(error => {
            this.type = this.$media.CONTENT_TYPE.ERROR;
            return throwError(error);
        }), finalize(() => this.loading$.next(false)));
    }
}
ImageComponent.ɵfac = function ImageComponent_Factory(t) { return new (t || ImageComponent)(ɵngcc0.ɵɵdirectiveInject(MediaService), ɵngcc0.ɵɵdirectiveInject(ɵngcc9.HttpClient), ɵngcc0.ɵɵdirectiveInject(ɵngcc16.DomSanitizer)); };
ImageComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ImageComponent, selectors: [["livesafe-image"]], inputs: { type: "type", src: "src" }, decls: 4, vars: 6, consts: [[3, "ngSwitch", 4, "ngIf"], [3, "ngSwitch"], [1, "background-image"], [4, "ngSwitchCase"], [3, "src", 4, "ngSwitchCase"], [3, "matTooltip", 4, "ngSwitchCase"], [3, "src"], [3, "matTooltip"]], template: function ImageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ImageComponent_ng_container_0_Template, 8, 7, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵtemplate(2, ImageComponent_ng_container_2_Template, 7, 7, "ng-container", 0);
        ɵngcc0.ɵɵpipe(3, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 2, ctx.loading$));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ɵngcc0.ɵɵpipeBind1(3, 4, ctx.loading$));
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, ɵngcc4.MatIcon, ɵngcc17.MatTooltip], pipes: [ɵngcc1.AsyncPipe], styles: ["[_nghost-%COMP%]{display:inline-block}img[_ngcontent-%COMP%]{-o-object-fit:cover;height:100%;left:0;object-fit:cover;position:absolute;text-indent:-10000px;top:0;width:100%}.mat-icon[_ngcontent-%COMP%]{font-size:20px;height:20px;left:1px;position:relative;top:-2px;vertical-align:middle;width:20px}"], changeDetection: 0 });
ImageComponent.ctorParameters = () => [
    { type: MediaService },
    { type: HttpClient },
    { type: DomSanitizer }
];
ImageComponent.propDecorators = {
    type: [{ type: Input }],
    src: [{ type: Input, args: ['src',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ImageComponent, [{
        type: Component,
        args: [{
                selector: 'livesafe-image',
                template: "<ng-container *ngIf=\"loading$ | async\" [ngSwitch]=\"type\">\n  <div class=\"background-image\">\n    <mat-icon *ngSwitchCase=\"$media.CONTENT_TYPE.IMAGE\">insert_photo</mat-icon>\n    <mat-icon *ngSwitchCase=\"$media.CONTENT_TYPE.VIDEO\">videocam</mat-icon>\n    <mat-icon *ngSwitchCase=\"$media.CONTENT_TYPE.AUDIO\">keyboard_voice</mat-icon>\n    <mat-icon *ngSwitchCase=\"$media.CONTENT_TYPE.TEXT\">description</mat-icon>\n    <mat-icon *ngSwitchCase=\"$media.CONTENT_TYPE.UNKNOWN\">block</mat-icon>\n    <mat-icon *ngSwitchCase=\"$media.CONTENT_TYPE.ERROR\">priority_high</mat-icon>\n  </div>\n</ng-container>\n<ng-container *ngIf=\"!(loading$ | async)\" [ngSwitch]=\"type\">\n  <img *ngSwitchCase=\"$media.CONTENT_TYPE.IMAGE\" [src]=\"src$ | async\" />\n  <mat-icon *ngSwitchCase=\"$media.CONTENT_TYPE.VIDEO\" [matTooltip]=\"TOOLTIP_MESSAGE.VIDEO\">videocam</mat-icon>\n  <mat-icon *ngSwitchCase=\"$media.CONTENT_TYPE.AUDIO\" [matTooltip]=\"TOOLTIP_MESSAGE.AUDIO\">keyboard_voice</mat-icon>\n  <mat-icon *ngSwitchCase=\"$media.CONTENT_TYPE.TEXT\" [matTooltip]=\"TOOLTIP_MESSAGE.TEXT\">description</mat-icon>\n  <mat-icon *ngSwitchCase=\"$media.CONTENT_TYPE.UNKNOWN\" [matTooltip]=\"TOOLTIP_MESSAGE.UNKNOWN\">block</mat-icon>\n  <mat-icon *ngSwitchCase=\"$media.CONTENT_TYPE.ERROR\" [matTooltip]=\"TOOLTIP_MESSAGE.ERROR\">priority_high</mat-icon>\n</ng-container>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{display:inline-block}img{-o-object-fit:cover;height:100%;left:0;object-fit:cover;position:absolute;text-indent:-10000px;top:0;width:100%}.mat-icon{font-size:20px;height:20px;left:1px;position:relative;top:-2px;vertical-align:middle;width:20px}"]
            }]
    }], function () { return [{ type: MediaService }, { type: ɵngcc9.HttpClient }, { type: ɵngcc16.DomSanitizer }]; }, { type: [{
            type: Input
        }], src: [{
            type: Input,
            args: ['src']
        }] }); })();

class ChatInputComponent {
    constructor() {
        this.placeholder = 'Reply';
        this.maxLength = 500;
        this.hasMediaAttached = false;
        this.sendMessage = new EventEmitter();
        this.startedTyping = new EventEmitter();
        this.messageForm = new FormGroup({
            message: new FormControl('', Validators.required)
        });
    }
    onSubmit() {
        this.sendMessage.emit({
            message: this.messageForm.get('message').value
        });
        this.messageForm.reset();
        this.resetErrorState();
    }
    resetErrorState() {
        // Open issue: resetting form doesn't reset the error state
        // Solution found here: https://github.com/angular/components/issues/4190#issuecomment-305118229
        Object.keys(this.messageForm.controls).forEach(key => {
            this.messageForm.controls[key].setErrors(null);
        });
    }
    get disableSend() {
        return (!this.messageForm.get('message').value || this.messageForm.get('message').value.length === 0) && !this.hasMediaAttached;
    }
}
ChatInputComponent.ɵfac = function ChatInputComponent_Factory(t) { return new (t || ChatInputComponent)(); };
ChatInputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ChatInputComponent, selectors: [["livesafe-chat-input"]], inputs: { placeholder: "placeholder", maxLength: "maxLength", hasMediaAttached: "hasMediaAttached" }, outputs: { sendMessage: "sendMessage", startedTyping: "startedTyping" }, decls: 5, vars: 4, consts: [[3, "formGroup", "ngSubmit"], ["appearance", "outline"], ["matInput", "", "livesafeMatStartedTyping", "", "rows", "1", "cdkTextareaAutosize", "", "cdkAutosizeMinRows", "1", "formControlName", "message", 3, "placeholder", "blur", "keydown.enter", "startedTyping"], ["mat-flat-button", "", "color", "primary", "livesafeMat", "", "type", "submit", 1, "send-button", "fg-0", 3, "disabled"]], template: function ChatInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵlistener("ngSubmit", function ChatInputComponent_Template_form_ngSubmit_0_listener() { return ctx.onSubmit(); });
        ɵngcc0.ɵɵelementStart(1, "mat-form-field", 1);
        ɵngcc0.ɵɵelementStart(2, "textarea", 2);
        ɵngcc0.ɵɵlistener("blur", function ChatInputComponent_Template_textarea_blur_2_listener() { return ctx.resetErrorState(); })("keydown.enter", function ChatInputComponent_Template_textarea_keydown_enter_2_listener() { ctx.onSubmit(); return false; })("startedTyping", function ChatInputComponent_Template_textarea_startedTyping_2_listener($event) { return ctx.startedTyping.emit($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "button", 3);
        ɵngcc0.ɵɵtext(4, " Send ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.messageForm);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("placeholder", ctx.placeholder);
        ɵngcc0.ɵɵattribute("maxlength", ctx.maxLength);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.disableSend);
    } }, directives: function () { return [ɵngcc10.ɵangular_packages_forms_forms_y, ɵngcc10.NgControlStatusGroup, ɵngcc10.FormGroupDirective, ɵngcc2.MatFormField, ɵngcc5.MatInput, ɵngcc18.CdkTextareaAutosize, ɵngcc10.DefaultValueAccessor, StartedTypingDirective, ɵngcc10.NgControlStatus, ɵngcc10.FormControlName, ɵngcc10.MaxLengthValidator, ɵngcc8.MatButton, ɵngcc3.LiveSafeMatDirective]; }, styles: ["[_nghost-%COMP%]{display:block;padding:8px 0;width:100%}form[_ngcontent-%COMP%]{align-items:end;display:grid;grid-column-gap:24px;grid-template-areas:\"left center right\";grid-template-columns:minmax(100px,1fr) minmax(auto,640px) minmax(100px,1fr)}mat-form-field[_ngcontent-%COMP%]{-ms-grid-column:3;-ms-grid-row:1;grid-area:center}mat-form-field[_ngcontent-%COMP%]     .mat-form-field-wrapper{padding-bottom:0!important}mat-form-field[_ngcontent-%COMP%]     .mat-input-element{margin:0;padding:0}mat-form-field[_ngcontent-%COMP%]     textarea{overflow-y:hidden}.send-button[_ngcontent-%COMP%]{-ms-grid-column:5;-ms-grid-row:1;bottom:4px;grid-area:right;height:45px;justify-self:start;position:relative}"], changeDetection: 0 });
ChatInputComponent.propDecorators = {
    placeholder: [{ type: Input }],
    maxLength: [{ type: Input }],
    hasMediaAttached: [{ type: Input }],
    sendMessage: [{ type: Output }],
    startedTyping: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ChatInputComponent, [{
        type: Component,
        args: [{
                selector: 'livesafe-chat-input',
                template: "<form [formGroup]=\"messageForm\" (ngSubmit)=\"onSubmit()\">\n\n  <mat-form-field appearance=\"outline\">\n    <textarea\n      matInput\n      livesafeMatStartedTyping\n      rows=\"1\"\n      [placeholder]=\"placeholder\"\n      cdkTextareaAutosize\n      cdkAutosizeMinRows=\"1\"\n      [attr.maxlength]=\"maxLength\"\n      (blur)=\"resetErrorState()\"\n      (keydown.enter)=\"onSubmit();false\"\n      (startedTyping)=\"startedTyping.emit($event)\"\n      formControlName=\"message\"\n    ></textarea>\n  </mat-form-field>\n\n  <button\n    mat-flat-button\n    color=\"primary\"\n    livesafeMat\n    class=\"send-button fg-0\"\n    type=\"submit\"\n    [disabled]=\"disableSend\"\n  >\n    Send\n  </button>\n</form>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{display:block;padding:8px 0;width:100%}form{align-items:end;display:grid;grid-column-gap:24px;grid-template-areas:\"left center right\";grid-template-columns:minmax(100px,1fr) minmax(auto,640px) minmax(100px,1fr)}mat-form-field{-ms-grid-column:3;-ms-grid-row:1;grid-area:center}mat-form-field ::ng-deep .mat-form-field-wrapper{padding-bottom:0!important}mat-form-field ::ng-deep .mat-input-element{margin:0;padding:0}mat-form-field ::ng-deep textarea{overflow-y:hidden}.send-button{-ms-grid-column:5;-ms-grid-row:1;bottom:4px;grid-area:right;height:45px;justify-self:start;position:relative}"]
            }]
    }], function () { return []; }, { placeholder: [{
            type: Input
        }], maxLength: [{
            type: Input
        }], hasMediaAttached: [{
            type: Input
        }], sendMessage: [{
            type: Output
        }], startedTyping: [{
            type: Output
        }] }); })();

class PaginatorComponent {
    constructor() {
        this.pageIndex = 0;
        this.pageSize = 25;
        this.moreItems = true;
        this.disabled = false;
        this.page = new EventEmitter();
    }
    nextPage() {
        if (!this.hasNextPage()) {
            return;
        }
        const previousPageIndex = this.pageIndex;
        this.pageIndex++;
        this._emitPageEvent(previousPageIndex);
    }
    previousPage() {
        if (!this.hasPreviousPage()) {
            return;
        }
        const previousPageIndex = this.pageIndex;
        this.pageIndex--;
        this._emitPageEvent(previousPageIndex);
    }
    hasPreviousPage() {
        return this.pageIndex >= 1 && this.pageSize !== 0;
    }
    hasNextPage() {
        return this.moreItems;
    }
    _nextButtonsDisabled() {
        return this.disabled || !this.hasNextPage();
    }
    _previousButtonsDisabled() {
        return this.disabled || !this.hasPreviousPage();
    }
    _emitPageEvent(previousPageIndex) {
        this.page.emit({
            previousPageIndex,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            moreItems: this.moreItems
        });
    }
}
PaginatorComponent.ɵfac = function PaginatorComponent_Factory(t) { return new (t || PaginatorComponent)(); };
PaginatorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PaginatorComponent, selectors: [["livesafe-paginator"]], inputs: { pageIndex: "pageIndex", pageSize: "pageSize", moreItems: "moreItems", disabled: "disabled" }, outputs: { page: "page" }, decls: 7, vars: 2, consts: [[1, "paginator-button-container"], ["mat-icon-button", "", "livesafeMat", "", "aria-label", "Previous page", 1, "prev", 3, "disabled", "click"], ["fontSet", "material-icons-round"], ["mat-icon-button", "", "livesafeMat", "", "aria-label", "Next page", 1, "next", 3, "disabled", "click"]], template: function PaginatorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "button", 1);
        ɵngcc0.ɵɵlistener("click", function PaginatorComponent_Template_button_click_1_listener() { return ctx.previousPage(); });
        ɵngcc0.ɵɵelementStart(2, "mat-icon", 2);
        ɵngcc0.ɵɵtext(3, "chevron_left");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "button", 3);
        ɵngcc0.ɵɵlistener("click", function PaginatorComponent_Template_button_click_4_listener() { return ctx.nextPage(); });
        ɵngcc0.ɵɵelementStart(5, "mat-icon", 2);
        ɵngcc0.ɵɵtext(6, "chevron_right");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx._previousButtonsDisabled());
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("disabled", ctx._nextButtonsDisabled());
    } }, directives: [ɵngcc8.MatButton, ɵngcc3.LiveSafeMatDirective, ɵngcc4.MatIcon], styles: [".next[_ngcontent-%COMP%]:disabled, .prev[_ngcontent-%COMP%]:disabled{background-color:transparent!important;color:rgba(0,0,0,.26)!important;cursor:default!important}"], changeDetection: 0 });
PaginatorComponent.propDecorators = {
    pageIndex: [{ type: Input }],
    pageSize: [{ type: Input }],
    moreItems: [{ type: Input }],
    disabled: [{ type: Input }],
    page: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PaginatorComponent, [{
        type: Component,
        args: [{
                selector: 'livesafe-paginator',
                template: "<div class=\"paginator-button-container\">\n  <button \n    class=\"prev\" \n    mat-icon-button \n    livesafeMat \n    aria-label=\"Previous page\" \n    (click)=\"previousPage()\"\n    [disabled]=\"_previousButtonsDisabled()\"\n  >\n    <mat-icon fontSet=\"material-icons-round\">chevron_left</mat-icon>\n  </button>\n\n  <button \n    class=\"next\" \n    mat-icon-button \n    livesafeMat \n    aria-label=\"Next page\" \n    (click)=\"nextPage()\"\n    [disabled]=\"_nextButtonsDisabled()\"\n  >\n    <mat-icon fontSet=\"material-icons-round\">chevron_right</mat-icon>\n  </button>\n</div>",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".next:disabled,.prev:disabled{background-color:transparent!important;color:rgba(0,0,0,.26)!important;cursor:default!important}"]
            }]
    }], function () { return []; }, { pageIndex: [{
            type: Input
        }], pageSize: [{
            type: Input
        }], moreItems: [{
            type: Input
        }], disabled: [{
            type: Input
        }], page: [{
            type: Output
        }] }); })();

class StartedTypingDirective {
    constructor() {
        this.canEmitEvent = false;
        this.startedTyping = new EventEmitter();
    }
    emitStartedTypingEvent($event) {
        if (this.canEmitEvent) {
            this.canEmitEvent = false;
            this.startedTyping.emit($event);
        }
    }
    setEmitEventOnFocus() {
        this.canEmitEvent = true;
    }
    setEmitEventOnSendMessage() {
        this.canEmitEvent = true;
    }
}
StartedTypingDirective.ɵfac = function StartedTypingDirective_Factory(t) { return new (t || StartedTypingDirective)(); };
StartedTypingDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: StartedTypingDirective, selectors: [["", "livesafeMatStartedTyping", ""]], hostBindings: function StartedTypingDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("input", function StartedTypingDirective_input_HostBindingHandler($event) { return ctx.emitStartedTypingEvent($event); })("focus", function StartedTypingDirective_focus_HostBindingHandler() { return ctx.setEmitEventOnFocus(); })("keydown.enter", function StartedTypingDirective_keydown_enter_HostBindingHandler() { return ctx.setEmitEventOnSendMessage(); });
    } }, outputs: { startedTyping: "startedTyping" } });
StartedTypingDirective.propDecorators = {
    startedTyping: [{ type: Output }],
    emitStartedTypingEvent: [{ type: HostListener, args: ['input', ['$event'],] }],
    setEmitEventOnFocus: [{ type: HostListener, args: ['focus',] }],
    setEmitEventOnSendMessage: [{ type: HostListener, args: ['keydown.enter',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StartedTypingDirective, [{
        type: Directive,
        args: [{
                selector: '[livesafeMatStartedTyping]'
            }]
    }], function () { return []; }, { startedTyping: [{
            type: Output
        }], emitStartedTypingEvent: [{
            type: HostListener,
            args: ['input', ['$event']]
        }], setEmitEventOnFocus: [{
            type: HostListener,
            args: ['focus']
        }], setEmitEventOnSendMessage: [{
            type: HostListener,
            args: ['keydown.enter']
        }] }); })();

class UpsaleHeroComponent {
    constructor() {
        this.colors = {
            main: '#0F1319',
            second: 'linear-gradient(50.11deg, rgba(221,233,248,0) 0%, rgba(15,19,25,0.32) 100%)',
            third: 'linear-gradient(50.11deg, rgba(221,233,248,0) 0%, rgba(15,19,25,0.32) 100%)'
        };
    }
}
UpsaleHeroComponent.ɵfac = function UpsaleHeroComponent_Factory(t) { return new (t || UpsaleHeroComponent)(); };
UpsaleHeroComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: UpsaleHeroComponent, selectors: [["livesafe-upsale-hero"]], inputs: { colors: "colors" }, ngContentSelectors: _c8, decls: 7, vars: 6, consts: [[1, "upsale-hero"], [1, "slanted-background"], [1, "section"], [1, "content"]], template: function UpsaleHeroComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "div", 2);
        ɵngcc0.ɵɵelement(4, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵprojection(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("background", ctx.colors.main);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("background", ctx.colors.second);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("background", ctx.colors.third);
    } }, styles: [".upsale-hero[_ngcontent-%COMP%]{position:relative}.upsale-hero[_ngcontent-%COMP%]   .slanted-background[_ngcontent-%COMP%]{display:grid;grid:repeat(5,110px)/repeat(10,1fr);height:850px;position:absolute;width:100%}@media screen and (max-width:760px){.upsale-hero[_ngcontent-%COMP%]   .slanted-background[_ngcontent-%COMP%]{top:-115px}}.upsale-hero[_ngcontent-%COMP%]   .slanted-background[_ngcontent-%COMP%]   .section[_ngcontent-%COMP%]{transform:skewY(-14deg);transform-origin:0}.upsale-hero[_ngcontent-%COMP%]   .slanted-background[_ngcontent-%COMP%]   .section[_ngcontent-%COMP%]:first-child{grid-column:1/-1;grid-row:span 5}.upsale-hero[_ngcontent-%COMP%]   .slanted-background[_ngcontent-%COMP%]   .section[_ngcontent-%COMP%]:nth-child(2){grid-column:1/-1;grid-row:span 2}.upsale-hero[_ngcontent-%COMP%]   .slanted-background[_ngcontent-%COMP%]   .section[_ngcontent-%COMP%]:nth-child(3){grid-column:1/-1;grid-row:span 2;opacity:.27}.upsale-hero[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{display:grid;grid-template-columns:465px 1fr;margin:0 auto;max-width:1360px;padding-left:160px;position:relative;z-index:2}@media screen and (max-width:599px){.upsale-hero[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{padding-left:24px}}@media screen and (max-width:760px){.upsale-hero[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{grid-template-columns:unset;margin-bottom:120px;margin-top:115px}}"] });
UpsaleHeroComponent.propDecorators = {
    colors: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UpsaleHeroComponent, [{
        type: Component,
        args: [{
                selector: 'livesafe-upsale-hero',
                template: "<div class=\"upsale-hero\">\n  <div class=\"slanted-background\">\n    <div class=\"section\" [style.background]=\"colors.main\"></div>\n    <div class=\"section\" [style.background]=\"colors.second\"></div>\n    <div class=\"section\" [style.background]=\"colors.third\"></div>\n  </div>\n  <div class=\"content\">\n    <ng-content></ng-content>\n  </div>\n</div>\n",
                styles: [".upsale-hero{position:relative}.upsale-hero .slanted-background{display:grid;grid:repeat(5,110px)/repeat(10,1fr);height:850px;position:absolute;width:100%}@media screen and (max-width:760px){.upsale-hero .slanted-background{top:-115px}}.upsale-hero .slanted-background .section{transform:skewY(-14deg);transform-origin:0}.upsale-hero .slanted-background .section:first-child{grid-column:1/-1;grid-row:span 5}.upsale-hero .slanted-background .section:nth-child(2){grid-column:1/-1;grid-row:span 2}.upsale-hero .slanted-background .section:nth-child(3){grid-column:1/-1;grid-row:span 2;opacity:.27}.upsale-hero .content{display:grid;grid-template-columns:465px 1fr;margin:0 auto;max-width:1360px;padding-left:160px;position:relative;z-index:2}@media screen and (max-width:599px){.upsale-hero .content{padding-left:24px}}@media screen and (max-width:760px){.upsale-hero .content{grid-template-columns:unset;margin-bottom:120px;margin-top:115px}}"]
            }]
    }], function () { return []; }, { colors: [{
            type: Input
        }] }); })();

class UpsaleSectionComponent {
    constructor() {
        this.background = { background: 'none' };
        this.textFirst = true;
        this.textContainerWidth = { width: '300px' };
        this.extraGridStyles = {};
    }
    getBackgroundStyle() {
        const { background, extras } = this.background;
        return extras ? Object.assign({ background }, extras) : { background };
    }
}
UpsaleSectionComponent.ɵfac = function UpsaleSectionComponent_Factory(t) { return new (t || UpsaleSectionComponent)(); };
UpsaleSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: UpsaleSectionComponent, selectors: [["livesafe-upsale-section"]], inputs: { background: "background", textFirst: "textFirst", textContainerWidth: "textContainerWidth", extraGridStyles: "extraGridStyles" }, ngContentSelectors: _c10, decls: 6, vars: 7, consts: [[1, "background", 3, "ngStyle"], [1, "grid", "section", 3, "ngStyle"], [1, "img-container"], [1, "text-container", 3, "ngStyle"]], template: function UpsaleSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c9);
        ɵngcc0.ɵɵelement(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵprojection(5, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngStyle", ctx.getBackgroundStyle());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngStyle", ctx.extraGridStyles);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("order", ctx.textFirst ? 2 : 1);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("order", ctx.textFirst ? 1 : 2);
        ɵngcc0.ɵɵproperty("ngStyle", ctx.textContainerWidth);
    } }, directives: [ɵngcc1.NgStyle], styles: ["[_nghost-%COMP%]{position:relative}[_nghost-%COMP%]   .background[_ngcontent-%COMP%]{height:100%;position:absolute;width:100%}[_nghost-%COMP%]   .grid[_ngcontent-%COMP%]{display:grid;grid-template-columns:40% 60%;margin:0 auto;max-width:1360px;padding:75px 0 75px 160px;position:relative;z-index:1}@media screen and (max-width:800px){[_nghost-%COMP%]   .grid[_ngcontent-%COMP%]{grid-template-columns:1fr!important;padding-right:20px}}@media screen and (max-width:599px){[_nghost-%COMP%]   .grid[_ngcontent-%COMP%]{padding:150px 0 0 24px}}[_nghost-%COMP%]   .img-container[_ngcontent-%COMP%]{align-items:center;display:flex}[_nghost-%COMP%]   .text-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center;justify-self:center;width:300px}@media screen and (max-width:800px){[_nghost-%COMP%]   .text-container[_ngcontent-%COMP%]{width:unset!important}}"] });
UpsaleSectionComponent.propDecorators = {
    background: [{ type: Input }],
    textFirst: [{ type: Input }],
    textContainerWidth: [{ type: Input }],
    extraGridStyles: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UpsaleSectionComponent, [{
        type: Component,
        args: [{
                selector: 'livesafe-upsale-section',
                template: "\n<div class=\"background\" [ngStyle]=\"getBackgroundStyle()\"></div>\n<div class=\"grid section\" [ngStyle]=\"extraGridStyles\">\n  <div class=\"img-container\" [style.order]=\"textFirst ? 2 : 1\">\n    <ng-content select=\"[img]\"></ng-content>\n  </div>\n  <div class=\"text-container\" [style.order]=\"textFirst ? 1 : 2\" [ngStyle]=\"textContainerWidth\">\n    <ng-content select=\"[text]\"></ng-content>\n  </div>\n</div>\n\n",
                styles: [":host{position:relative}:host .background{height:100%;position:absolute;width:100%}:host .grid{display:grid;grid-template-columns:40% 60%;margin:0 auto;max-width:1360px;padding:75px 0 75px 160px;position:relative;z-index:1}@media screen and (max-width:800px){:host .grid{grid-template-columns:1fr!important;padding-right:20px}}@media screen and (max-width:599px){:host .grid{padding:150px 0 0 24px}}:host .img-container{align-items:center;display:flex}:host .text-container{display:flex;flex-direction:column;justify-content:center;justify-self:center;width:300px}@media screen and (max-width:800px){:host .text-container{width:unset!important}}"]
            }]
    }], function () { return []; }, { background: [{
            type: Input
        }], textFirst: [{
            type: Input
        }], textContainerWidth: [{
            type: Input
        }], extraGridStyles: [{
            type: Input
        }] }); })();

function gmapsApiKeyFactory(options) {
    return options.gmapsApiKey;
}
function countriesPathFactory(options) {
    return options.countriesPath;
}
class LiveSafeCommonModule {
    static forRoot(options) {
        return {
            ngModule: LiveSafeCommonModule,
            providers: [
                { provide: LIVESAFE_COMMON_OPTIONS, useValue: options },
                {
                    provide: GMAPS_API_KEY,
                    useFactory: gmapsApiKeyFactory,
                    deps: [LIVESAFE_COMMON_OPTIONS]
                },
                {
                    provide: COUNTRIES_ASSET_PATH,
                    useFactory: countriesPathFactory,
                    deps: [LIVESAFE_COMMON_OPTIONS]
                }
            ]
        };
    }
}
LiveSafeCommonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: LiveSafeCommonModule });
LiveSafeCommonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function LiveSafeCommonModule_Factory(t) { return new (t || LiveSafeCommonModule)(); }, imports: [[
            CommonModule,
            LiveSafeMaterialModule,
            ReactiveFormsModule,
            TimeagoModule.forRoot(),
            LayoutModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LiveSafeCommonModule, { declarations: function () { return [MapComponent, PhoneFieldComponent, ColorPickerComponent, AlertDialogComponent, ChatComponent, ChatInputComponent, MediaComponent, ImageComponent, UnescapePipe, PaginatorComponent, StartedTypingDirective, UpsaleHeroComponent, UpsaleSectionComponent]; }, imports: function () { return [CommonModule,
        LiveSafeMaterialModule,
        ReactiveFormsModule, ɵngcc15.TimeagoModule, LayoutModule]; }, exports: function () { return [MapComponent, PhoneFieldComponent, ColorPickerComponent, AlertDialogComponent, ChatComponent, ChatInputComponent, MediaComponent, ImageComponent, UnescapePipe, PaginatorComponent, StartedTypingDirective, UpsaleHeroComponent, UpsaleSectionComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LiveSafeCommonModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    MapComponent,
                    PhoneFieldComponent,
                    ColorPickerComponent,
                    AlertDialogComponent,
                    ChatComponent,
                    ChatInputComponent,
                    MediaComponent,
                    ImageComponent,
                    UnescapePipe,
                    PaginatorComponent,
                    StartedTypingDirective,
                    UpsaleHeroComponent,
                    UpsaleSectionComponent
                ],
                imports: [
                    CommonModule,
                    LiveSafeMaterialModule,
                    ReactiveFormsModule,
                    TimeagoModule.forRoot(),
                    LayoutModule
                ],
                exports: [
                    MapComponent,
                    PhoneFieldComponent,
                    ColorPickerComponent,
                    AlertDialogComponent,
                    ChatComponent,
                    ChatInputComponent,
                    MediaComponent,
                    ImageComponent,
                    UnescapePipe,
                    PaginatorComponent,
                    StartedTypingDirective,
                    UpsaleHeroComponent,
                    UpsaleSectionComponent
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of common
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AlertDialogComponent, Cache, CacheService, ChatComponent, ChatInputComponent, ColorPickerComponent, Coordinates, CountriesService, DefaultCountryList, GEOLOCATION_API, GeolocationService, ImageComponent, LIVESAFE_COMMON_OPTIONS, LiveSafeCommonModule, Location, MapComponent, MapService, MapsApiLoader, MarkerOptions, MediaComponent, MediaService, PaginatorComponent, PhoneFieldComponent, ScriptService, UnescapePipe, countriesPathFactory, geolocationFactory, gmapsApiKeyFactory, patch, silverGoogleMapsStyle, GMAPS_API_KEY as ɵa, COUNTRIES_ASSET_PATH as ɵb, StartedTypingDirective as ɵc, UpsaleHeroComponent as ɵd, UpsaleSectionComponent as ɵe };

//# sourceMappingURL=livesafe-common.js.map